import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { Card } from 'react-bootstrap';
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import Select from 'react-select';
import { style } from "variables/Variables.jsx";
import { css } from "@emotion/core";
import { BeatLoader } from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $, { post } from 'jquery';
import CommonNavbar, { navbar } from "./commonNavbar";
import moment from 'moment';
import DatePicker from "react-datepicker";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

// Helper function to convert amount to K notation
const convertToKNotation = (amount) => {
  if (!amount || amount === '') return '';
  const numAmount = Number(amount);
  if (isNaN(numAmount)) return '';

  if (numAmount >= 1000) {
    const value = Math.floor((numAmount / 1000) * 100) / 100;
    return value.toString().replace(/\.0+$/, '') + 'K';
  }

  return numAmount.toString();
};

// Modal: do you want to save your record
class AdminNewCreateSchemesBankEMI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      brand_file_uploaded: [],
      mvalue: { year: new Date().getFullYear(), month: 11 },
      _notificationSystem: null,
      timer: null,
      loading: true,
      isSubmit: false,
      file_name: "",
      notify: null,
      activer: [],
      is_download: false,
      uploadDropdown: false,
      errorModel: false,
      noErrorModel: false,
      file_id_got: null,
      report_file_name: null,
      error_message: null,
      error_message_header: null,
      open_instructions: false,
      scheme_name: 'Scheme name will be auto-generated',
      tid: '',
      // bank_options: [
      //     { value: 'AMEX BANK', label: 'AMEX BANK', value1: 'ISB0000000010'},
      //     { value: 'AXIS BANK', label: 'AXIS BANK', value1: 'ISB0000000003'},
      //     { value: 'CITIBANK', label: 'CITIBANK', value1: 'ISB0000000005'},
      //     { value: 'HDFC Bank', label: 'HDFC Bank', value1: 'ISB0000000001'},
      //     { value: 'HSBC Bank', label: 'HSBC Bank', value1: 'ISB0000000007'},
      //     { value: 'ICICI Bank', label: 'ICICI Bank', value1: 'ISB0000000002'},
      //     { value: 'INDUSIND BANK', label: 'INDUSIND BANK', value1: 'ISB0000000011'},
      //     { value: 'KOTAK BANK', label: 'KOTAK BANK', value1: 'ISB0000000008'},
      //     { value: 'RBL BANK', label: 'RBL BANK', value1: 'ISB0000000013'},
      //     { value: 'SBI CARD', label: 'SBI CARD', value1: 'ISB0000000009'},
      //     { value: 'STANDARD CHARTERED BANK', label: 'STANDARD CHARTERED BANK', value1: 'ISB0000000006'},
      //     { value: 'YES BANK', label: 'YES BANK', value1: 'ISB0000000014'}
      // ],
      bank_options: [],
      // month_tenure: [
      //     { value: 3, label: '3 months', value1: 'TR003'},
      //     { value: 6, label: '6 months', value1: 'TR004'},
      //     { value: 9, label: '9 months', value1: 'TR005'},
      //     { value: 12, label: '12 months', value1: 'TR006'}
      // ],
      selected_bank: null,
      selected_bank_code: null,
      selected_tenure: null,
      selected_tenure_code: null,

      //need to comment
      cashback_type: 'flat',

      //upfront cashback
      upfront_cashback_type: 'flat',
      upfront_define_max: false,
      upfront_amounter: '',
      upfront_max_amounter: '',


      //post cashback
      post_cashback_type: 'flat',
      post_define_max: false,
      post_amounter: '',
      post_max_amounter: '',


      scheme_type: 'brandemi',
      pre_or_post: 'pre',

      //need to comment
      amounter: '',
      max_amounter: '',
      define_max: false,

      is_emi: true,

      // need to comment
      is_cashback: false,

      is_upfront_cashback: false,
      is_post_cashback: false,
      emiMenus: [],
      is_duplicate: null,
      party_options: [
        { value: 'Brand', label: 'Brand' },
        { value: 'Merchant', label: 'Merchant' }
      ],
      party_list: [],
      selected_party_type: null,
      selected_party: null,
      selected_party_type2: null,
      selected_party2: [{ value: null, label: null }],
      upload_user_type: null,
      brand_emi: 100,
      merchant_emi: 0,
      bank_emi: 0,
      innoviti_emi: 0,
      customer_emi: 0,


      // need to comment
      brand_cb: 100,
      merchant_cb: 0,
      bank_cb: 0,
      innoviti_cb: 0,
      customer_cb: 0,


      // upfront cashback
      upfront_brand_cb: 100,
      upfront_merchant_cb: 0,
      upfront_bank_cb: 0,
      upfront_innoviti_cb: 0,
      upfront_customer_cb: 0,

      // post cashback
      post_brand_cb: 100,
      post_merchant_cb: 0,
      post_bank_cb: 0,
      post_innoviti_cb: 0,
      post_customer_cb: 0,


      txn_amount: 50000,
      isCalculate: false,
      processing_fees: 0,
      roi: 0,
      effective_roi: 0,
      selected_bank_pre: 'POST',
      user_type: 'admin',
      additional_contains: '',
      additional_terms_conditions: '',
      emi_type: '0',
      low_cost_subvention: '',
      start_date: moment(new Date()).format('YYYY-MM-DD'),
      end_date: moment(new Date()).format('YYYY-MM-DD'),
      interest_rate: 1.00,
      enableDisablePartyType: 'none',
      subvention_participants: '0',
      bank_max_limit_on_cashback: '',
      bank_share_of_tx: '',
      canCreateScheme: false,
      cooldownRemaining: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.cooldownTimer = null;
  }
  isUPIBank = (bankValue) => {
    if (!bankValue) return false;
    // Handle both string value and object with value property
    const bankName = typeof bankValue === 'string' ? bankValue : (bankValue.value || '');
    return bankName.toLowerCase().includes('upi');
  };

  // Add these methods to your class
  startCooldown = (seconds) => {
    this.setState({ cooldownRemaining: seconds });

    this.cooldownTimer = setInterval(() => {
      this.setState(prevState => {
        if (prevState.cooldownRemaining <= 1) {
          // Cooldown finished
          clearInterval(this.cooldownTimer);
          this.cooldownTimer = null;
          return { cooldownRemaining: 0 };
        }
        return { cooldownRemaining: prevState.cooldownRemaining - 1 };
      });
    }, 1000);
  };

  resetCooldown = () => {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
      this.cooldownTimer = null;
    }
    this.setState({ cooldownRemaining: 0 });
  };

  // Add this method to generate scheme name
  generateSchemeName = () => {
    const {
      selected_bank,
      is_emi,
      emi_type,
      selected_tenure,
      is_upfront_cashback,
      is_post_cashback,
      upfront_cashback_type,
      upfront_amounter,
      upfront_max_amounter,
      selected_party2,
      low_cost_subvention,
      post_cashback_type,
      post_amounter,
      post_max_amounter
    } = this.state;

    let schemeNameParts = [];

    // 1. Bank & Card Type Prefix
    if (selected_bank) {
      const bankDisplayName = selected_bank.value || selected_bank;
      let bankPrefix = '';

      if (bankDisplayName && typeof bankDisplayName === 'string') {

        if (bankDisplayName.toLowerCase().includes('baroda')) {
          bankPrefix = 'BOB_CC';
        }
        else if (bankDisplayName.toLowerCase().includes('upi')) {
          bankPrefix = 'UPI';
        }
        // Check if it's DC EMI
        else if (bankDisplayName.toLowerCase().includes('dc emi')) {
          const bankName = bankDisplayName.split(' ')[0]; // Get first word (HDFC, ICICI, etc.)
          bankPrefix = `${bankName}_DC`;
        } else {
          const bankName = bankDisplayName.split(' ')[0];
          bankPrefix = `${bankName}_CC`;
        }
        schemeNameParts.push(bankPrefix);
      }
    }

    // 3. Tenure Suffix
    if (selected_tenure && is_emi) {
      schemeNameParts.push(`${selected_tenure}M`);
    }
    // 3. EMI Type Abbreviation
    if (is_emi) {
      let emiTypeAbbr = '';

      if (emi_type === '0') {
        // Zero Cost EMI
        emiTypeAbbr = 'NCE';
      } else if (emi_type === '1') {
        // Low Cost EMI
        // Handle empty string, null, or undefined
        if (low_cost_subvention === '' || low_cost_subvention === null || low_cost_subvention === undefined) {
          // If no value is entered, default to LCE
          emiTypeAbbr = 'LCE';
        } else {
          const subventionValue = Number(low_cost_subvention);

          if (!isNaN(subventionValue)) {
            if (subventionValue === 0) {
              // Low Cost with 0% subvention
              emiTypeAbbr = 'CIB';
            } else {
              // Low Cost with >0% subvention
              emiTypeAbbr = 'LCE';
            }
          } else {
            // Invalid number, default to LCS
            emiTypeAbbr = 'LCE';
          }
        }
      }

      if (emiTypeAbbr) {
        schemeNameParts.push(emiTypeAbbr);
      }
    }

    if (!is_emi) {
      const emiTypeAbbr = 'FLAT';
      schemeNameParts.push(emiTypeAbbr);
    }



    // 4. Upfront Cashback Value (Flat Only)
    // if (is_upfront_cashback && upfront_cashback_type === 'flat' && upfront_amounter) {
    //   const cashbackK = convertToKNotation(upfront_amounter);
    //   if (cashbackK) {
    //     schemeNameParts.push(cashbackK);
    //   }
    // }

    // 4. Upfront Cashback Value (Flat or Percentage)
    if (is_upfront_cashback && upfront_amounter) {
      if (upfront_cashback_type === 'flat') {
        // Flat amount: Convert to K notation (e.g., 2500 → 2.5K)
        const cashbackK = convertToKNotation(upfront_amounter);
        if (cashbackK) {
          schemeNameParts.push(cashbackK);
        }
      } else if (upfront_cashback_type === 'percent') {
        // Percentage: Add "P" suffix (e.g., 10 → 10P)
        const percentValue = Number(upfront_amounter);
        if (!isNaN(percentValue) && percentValue > 0) {
          schemeNameParts.push(`${percentValue}P`);

          // If max cashback amount is defined, add it too
          // If max cashback amount is defined and not equal to sentinel value (99999), add it too
          if (upfront_max_amounter && upfront_max_amounter !== '') {
            const maxAmountNum = Number(upfront_max_amounter);
            // Check if it's a valid number AND less than 100000 (to exclude 99999 and higher)
            if (!isNaN(maxAmountNum) && maxAmountNum < 40000) {
              const maxCashbackK = convertToKNotation(upfront_max_amounter);
              if (maxCashbackK) {
                schemeNameParts.push(maxCashbackK);
              }
            }
          }
        }
      }
    }

    if (post_amounter && is_post_cashback) {
      if (post_cashback_type === 'flat') {
        // Flat amount: Convert to K notation (e.g., 2500 → 2.5K)
        const cashbackK = convertToKNotation(post_amounter);
        if (cashbackK) {
          schemeNameParts.push(cashbackK);
        }
      } else if (post_cashback_type === 'percent') {
        // Percentage: Add "P" suffix (e.g., 10 → 10P)
        const percentValue = Number(post_amounter);
        if (!isNaN(percentValue) && percentValue > 0) {
          schemeNameParts.push(`${percentValue}P`);
          // If max cashback amount is defined, add it too
          if (post_max_amounter && post_max_amounter !== '') {
            const maxAmountNum = Number(post_max_amounter);
            // Check if it's a valid number AND less than 100000 (to exclude 99999 and higher)
            if (!isNaN(maxAmountNum) && maxAmountNum < 40000) {
              const maxCashbackK = convertToKNotation(post_max_amounter);
              if (maxCashbackK) {
                schemeNameParts.push(maxCashbackK);
              }
            }
          }
        }
      }
    }

    // 5. Cashback Type Suffix (IBD / ICB)
    // if (is_upfront_cashback && upfront_cashback_type === 'flat' && upfront_amounter) {
    //   const brandName = selected_party2 && selected_party2[0] && selected_party2[0].label;
    //   const isSamsung = brandName && brandName.toLowerCase().includes('samsung');
    //   const cashbackSuffix = isSamsung ? 'IBD' : 'ICB';
    //   schemeNameParts.push(cashbackSuffix);
    // }

    // 5. Cashback Type Suffix (IBD / ICB)
    if (is_upfront_cashback && upfront_amounter) {
      const brandName = selected_party2 && selected_party2[0] && selected_party2[0].label;
      const isSamsung = brandName && brandName.toLowerCase().includes('samsung');
      const cashbackSuffix = isSamsung ? 'IBD' : 'ICB';
      schemeNameParts.push(cashbackSuffix);
    }
    else if (is_post_cashback) {
      const cashbackSuffix = 'CB';
      schemeNameParts.push(cashbackSuffix);

    }

    // Join all parts with underscore
    const generatedName = schemeNameParts.join('_');

    // Return the generated name or placeholder
    return generatedName || 'Scheme name will be auto-generated';
  };

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: (
        <div>
          {msg}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5
    });
  };

  componentDidMount() {
    const cancreateScheme = this.canCreateScheme();
    this.setState({
      canCreateScheme: cancreateScheme
    });
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    if (decoded.userGroup == 1 || decoded.userGroup == '1') {
      this.setState({
        user_type: 'admin',
        _notificationSystem: this.refs.notificationSystem
      });
    } else {
      this.setState({
        user_type: 'other',
        _notificationSystem: this.refs.notificationSystem
      });
    }
    this.getBankList();
    this.getPartyID();
    this.getMonthTenure();
    //var _notificationSystem = this.refs.notificationSystem;
    // this.getBrandUploadedData();
    const locFlexipay = JSON.parse(localStorage.getItem("locFlexipay"));
    var divDis = "none";
    if (locFlexipay === '1' || locFlexipay === 1) {
      divDis = "none";
      this.setState({
        selected_party_type2: [{ value: "Brand", label: "Brand" }],
        selected_party2: [{ value: 35, label: "Default" }],
        selected_party_type: [{ value: "Brand", label: "Brand" }],
        selected_party: [{ value: 35, label: "Default" }],
      });
    } else {
      divDis = "block";
    }

    this.setState({
      enableDisablePartyType: divDis
    })
  }

  componentDidUpdate(prevProps, prevState) {
    // Regenerate scheme name when relevant state changes
    const relevantFields = [
      'selected_bank',
      'emi_type',
      'selected_tenure',
      'is_upfront_cashback',
      'upfront_cashback_type',
      'upfront_amounter',
      'upfront_max_amounter',
      'selected_party2',
      'low_cost_subvention',
      'is_emi'
    ];

    const hasRelevantChange = relevantFields.some(field =>
      prevState[field] !== this.state[field]
    );

    if (hasRelevantChange) {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== this.state.scheme_name && newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    }

    if (
      prevState.selected_bank !== this.state.selected_bank ||
      prevState.selected_tenure !== this.state.selected_tenure ||
      prevState.selected_party !== this.state.selected_party
    ) {
      this.fetchROI(this.state.selected_bank_code, this.state.selected_tenure_code, this.state.selected_party);
    }
  }

  componentWillUnmount() {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
    }
  }

  canCreateScheme = () => {
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    console.log("Decoded user ID:", decoded._id);
    // List of user IDs who can stop promotions
    const allowedUsers = process.env.REACT_APP_ALLOWED_USER;
    console.log("Allowed users:", allowedUsers);
    return allowedUsers.includes(decoded._id);
  }

  fetchROI = (bank, tenure, party) => {
    if (!bank || !tenure) return;

    const payload = {
      bank_code: bank,
      tenure_code: tenure,
    };

    if (party) {
      payload.party = party;
    }

    axios
      .post(config.get("API_URL") + "/brandemi/get_roi_values", payload, {
        headers: {
          Authorization: `${localStorage.usertoken}`,
        },
      })
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const values = response.data[0];
          this.setState({
            roi: values.roi,
            effectiveRoi: values.effectiveRoi,
            loading: false,
          });
        } else {

        }
      })
      .catch((error) => {
        console.error("Failed to fetch ROI", error);
        this.handleNotificationClick("tr", 3, "Failed to fetch ROI");
        this.setState({
          roi: "",
          effectiveRoi: "",
          isSubmit: false,
          loading: false
        });
      });
  };


  getMonthTenure() {

    const locFlexipay = JSON.parse(localStorage.getItem("locFlexipay"));

    var tenureURL = "findAllTenures";
    if (locFlexipay === '1' || locFlexipay === 1) {
      tenureURL = "findAllTenures";
    } else {
      tenureURL = "findAllTenures";
    }

    axios.get(config.get('API_URL') + '/brandemi/' + tenureURL, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      }
    }).then(response => {
      // console.log(response.data);
      let month_tenure = [];
      if (Array.isArray(response.data._embedded.tenures) && response.data._embedded.tenures.length) {
        response.data._embedded.tenures.map((valuea, index) => {
          if (valuea.emi_tenure_code != 'XXXXX') {
            month_tenure.push({
              value: valuea.tenureMonth,
              label: valuea.tenureDisplayName,
              value1: valuea.innoTenureCode
            });
          }
        });
        this.setState({
          month_tenure: month_tenure
        })
      }
    });
  }

  getBankList() {
    axios.get(config.get('API_URL') + '/brandemi/findAllIssuerBanks', {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      }
    }).then(response => {
      console.log(response.data._embedded.issuerBanks);
      let bank_options = [];
      if (Array.isArray(response.data._embedded.issuerBanks) && response.data._embedded.issuerBanks.length) {
        response.data._embedded.issuerBanks.map((valuea, index) => {
          bank_options.push({
            value: valuea.issuerBankDisplayName,
            label: valuea.issuerBankDisplayName,
            value1: valuea.innoIssuerBankCode,
            value2: valuea.issuerDefaultCashbackFlag
          })
        });
        this.setState({
          bank_options: bank_options
        })
      }
    });
  }

  handleFromChange = date => {
    this.setState({
      start_date: moment(date).format('YYYY-MM-DD'),
      mapField2: false
    });
  };

  handleToChange = date => {
    this.setState({
      end_date: moment(date).format('YYYY-MM-DD'),
      mapField2: false
    });
  };

  updatePartyType = (valuer) => {
    if (valuer.value == 'Merchant') {
      this.handleNotificationClick("tr", 3, "Merchant schemes is under construction.");
      // this.setState({
      //     selected_party_type: valuer.value,
      //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
      //     uploadDropdown: false,
      //     upload_user_type: 2,
      //     loading: true,
      //     selected_party: null,
      //     selected_party2: null,
      //     party_list: [],
      //     party_master_id: 5,
      // }, () => {
      //     this.getPartyList();
      //     this.getBrandUploadedData();
      // });
    } else if (valuer.value == 'Brand') {
      this.setState({
        selected_party_type: valuer.value,
        selected_party_type2: [{ value: valuer.value, label: valuer.label }],
        uploadDropdown: false,
        upload_user_type: 7,
        loading: true,
        selected_party: null,
        selected_party2: [{ value: null, label: null }],
        party_master_id: null,
        party_list: []
      }, () => {
        this.getPartyList();
      });
    }
  };

  updatePartyValue = (valuer) => {
    this.setState({
      selected_party: valuer.value,
      selected_party2: [{ value: valuer.value, label: valuer.label }],
      party_master_id: valuer.value,
      loading: false,
      uploadDropdown: false
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  getPartyList = () => {
    const token = localStorage.usertoken;
    axios.get(config.get('API_URL') + '/brandemi/findAllManufacturers',
      {
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        }
      })
      .then(response => {
        console.log(response);
        let party_list = [];
        this.setState({
          party_list: [],
          selected_party: null
        });
        response.data.map((values, index) => {
          party_list.push({ value: values.id, label: values.party_name })
        });
        this.setState({
          party_list: party_list,
          loading: false
        })
      });
  }

  handleUpfrontMaxAmountChange = (e) => {
    let { upfront_max_amounter } = this.state;
    upfront_max_amounter = e.target.value;
    this.setState({
      upfront_max_amounter: upfront_max_amounter,
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  handlePostMaxAmountChange = (e) => {
    let { post_max_amounter } = this.state;
    post_max_amounter = e.target.value;
    this.setState({
      post_max_amounter: post_max_amounter
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  getPartyID() {
    if ($.fn.DataTable.isDataTable('#party_showTable')) {
      $('#party_showTable').DataTable().destroy();
    }
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);


    axios.get(config.get('API_URL') + '/brandemi/get_party_id', {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      },
      params: {
        user_id: decoded._id,
      }
    }).then(response => {
      console.log(response.data);
      if (response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')) {
        this.setState({
          party_master_id: 3,
          loading: false,
          user_id: decoded._id
        });
      } else {
        response.data.map((values, index) => {
          let selected_party2 = [];
          response.data.map((values, index) => {
            let to_add = '';
            if (values.party_id == '4' || values.party_id == 4) {
              to_add = 'APPLE';
            } else if (values.party_id == '5' || values.party_id == 5) {
              to_add = 'XIAOMI';
            }
            selected_party2.push({ value: values.id, label: to_add })
          });
          this.setState({
            selected_party2: selected_party2,
            loading: false
          })
          console.log(values.party_id);
          this.setState({
            party_master_id: values.party_id
          })
        })
        this.setState({
          party_id_mapper: response.data
        });
        $('#party_showTable').DataTable();
        this.setState({
          loading: false,
          user_id: decoded._id
        });
      }
    });
  }


  // getDuplicate(valor) {
  //   const token = localStorage.usertoken;
  //   const decoded = jwt_decode(token);
  //   const locFlexipay = JSON.parse(localStorage.getItem("locFlexipay"));

  //   axios.get(config.get('API_URL') + '/brandemi/check_duplicate_schemes', {
  //     headers: {
  //       Authorization: ` ${localStorage.usertoken}`
  //     },
  //     params: {
  //       party_master_id: this.state.party_master_id,
  //       scheme_name: this.state.scheme_name
  //     }
  //   }).then(response => {
  //     if (response.data.length === 0) {
  //       const token = localStorage.usertoken;
  //       const decoded = jwt_decode(token);
  //       const data = new FormData();
  //       data.append('scheme_name', this.state.scheme_name);
  //       data.append('bank_name', this.state.selected_bank);
  //       data.append('selected_bank_code', this.state.selected_bank_code);
  //       data.append('is_emi', (this.state.is_emi ? 1 : 0));
  //       data.append('user_type', decoded.userGroup);
  //       if (this.state.selected_tenure == null || this.state.is_emi == false) {
  //         data.append('tenure', 1);
  //       } else {
  //         data.append('tenure', this.state.selected_tenure);
  //       }
  //       data.append('party_master_id', this.state.party_master_id);
  //       data.append('is_cashback', (this.state.is_cashback ? 1 : 0));
  //       data.append('is_upfront_cashback', (this.state.is_upfront_cashback ? 1 : 0));
  //       data.append('is_post_cashback', (this.state.is_post_cashback ? 1 : 0));
  //       data.append('user_id', decoded._id);

  //       //need to comment
  //       data.append('brand_sub', this.state.cashback_type);


  //       data.append('upfront_brand_sub', this.state.upfront_cashback_type);
  //       data.append('post_brand_sub', this.state.post_cashback_type);

  //       //need to comment
  //       data.append('brand_sub_amount', this.state.amounter);


  //       data.append('upfront_brand_sub_amount', this.state.upfront_amounter);
  //       data.append('post_brand_sub_amount', this.state.post_amounter);
  //       //need to comment
  //       if (this.state.define_max == false) {
  //         data.append('max_cashback', -1);
  //       } else {
  //         data.append('max_cashback', this.state.max_amounter);
  //       }


  //       if (this.state.upfront_define_max == false) {
  //         data.append('upfront_max_cashback', this.state.upfront_max_amounter);
  //       } else {
  //         data.append('upfront_max_cashback', this.state.upfront_max_amounter);
  //       }


  //       if (this.state.post_define_max == false) {
  //         data.append('post_max_cashback', this.state.post_max_amounter);
  //       } else {
  //         data.append('post_max_cashback', this.state.post_max_amounter);
  //       }


  //       // need to comment
  //       if (this.state.pre_or_post == 'pre') {
  //         data.append('is_upfront', 1);
  //       }
  //       // need to comment
  //       else {
  //         data.append('is_upfront', 0);
  //       }


  //       if (this.state.emi_type == '0') {
  //         data.append('emi_type', 0);
  //       } else {
  //         data.append('emi_type', 1);
  //       }
  //       data.append('brand_emi', this.state.brand_emi);
  //       data.append('bank_emi', this.state.bank_emi);
  //       data.append('merchant_emi', this.state.merchant_emi);
  //       data.append('innoviti_emi', this.state.innoviti_emi);
  //       data.append('customer_emi', this.state.customer_emi);

  //       // need to comment
  //       data.append('brand_cb', this.state.brand_cb);
  //       data.append('bank_cb', this.state.bank_cb);
  //       data.append('merchant_cb', this.state.merchant_cb);
  //       data.append('innoviti_cb', this.state.innoviti_cb);
  //       data.append('customer_cb', this.state.customer_cb);


  //       //post cashback
  //       data.append('upfront_brand_cb', this.state.upfront_brand_cb);
  //       data.append('upfront_bank_cb', this.state.upfront_bank_cb);
  //       data.append('upfront_merchant_cb', this.state.upfront_merchant_cb);
  //       data.append('upfront_innoviti_cb', this.state.upfront_innoviti_cb);
  //       data.append('upfront_customer_cb', this.state.upfront_customer_cb);


  //       // upfront cashback
  //       data.append('post_brand_cb', this.state.post_brand_cb);
  //       data.append('post_bank_cb', this.state.post_bank_cb);
  //       data.append('post_merchant_cb', this.state.post_merchant_cb);
  //       data.append('post_innoviti_cb', this.state.post_innoviti_cb);
  //       data.append('post_customer_cb', this.state.post_customer_cb);


  //       data.append('processing_fees', this.state.processing_fees);
  //       data.append('pre_or_post', this.state.selected_bank_pre);
  //       data.append('tid', this.state.tid);
  //       data.append('scheme_type', this.state.scheme_type);
  //       data.append('additional_contains', this.state.additional_contains);
  //       data.append('additional_terms_conditions', this.state.additional_terms_conditions);
  //       data.append('low_cost_subvention', this.state.low_cost_subvention);
  //       data.append('interest_rate', this.state.interest_rate);
  //       data.append('start_date', this.state.start_date);
  //       data.append('end_date', this.state.end_date);
  //       data.append('flexipay', locFlexipay);
  //       data.append('bank_max_per_cb', this.state.bank_max_limit_on_cashback);
  //       data.append('bank_cb_per', this.state.bank_share_of_tx);
  //       data.append('is_variable', this.state.subvention_participants);

  //       axios.post(config.get('API_URL') + "/brandemi/create_new_scheme_new_bankemi", data, {
  //         headers: {
  //           Authorization: ` ${localStorage.usertoken}`
  //         }
  //       })
  //         .then(res => {
  //           if (res.status == 200) {
  //             this.handleNotificationClick("tr", 1, "Scheme added successfully");
  //             this.setState({
  //               isSubmit: false,
  //               loading: false
  //             });
  //           }
  //           else {
  //             this.handleNotificationClick("tr", 3, "API error");
  //             this.setState({
  //               isSubmit: false,
  //               loading: false
  //             });
  //           }
  //         })
  //         .catch(err => { // then print response status
  //           this.handleNotificationClick("tr", 3, "Something Wrong!");
  //           this.setState({
  //             isSubmit: false,
  //             loading: false
  //           })
  //         });
  //     } else {
  //       this.handleNotificationClick("tr", 3, "Duplicate Scheme Name");
  //       this.setState({
  //         loading: false
  //       })
  //     }
  //   });
  // }
  getDuplicate(valor) {

    this.setState({ isSubmit: true, loading: true });

    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    const locFlexipay = JSON.parse(localStorage.getItem("locFlexipay"));


    // Proceed with creating the scheme
    const data = new FormData();
    data.append('scheme_name', this.state.scheme_name);
    data.append('bank_name', this.state.selected_bank);
    data.append('selected_bank_code', this.state.selected_bank_code);
    data.append('is_emi', (this.state.is_emi ? 1 : 0));
    data.append('user_type', decoded.userGroup);
    if (this.state.selected_tenure == null || this.state.is_emi == false) {
      data.append('tenure', 1);
    } else {
      data.append('tenure', this.state.selected_tenure);
    }
    data.append('party_master_id', this.state.party_master_id);
    data.append('is_cashback', (this.state.is_cashback ? 1 : 0));
    data.append('is_upfront_cashback', (this.state.is_upfront_cashback ? 1 : 0));
    data.append('is_post_cashback', (this.state.is_post_cashback ? 1 : 0));
    data.append('user_id', decoded._id);

    //need to comment
    data.append('brand_sub', this.state.cashback_type);

    data.append('upfront_brand_sub', this.state.upfront_cashback_type);
    data.append('post_brand_sub', this.state.post_cashback_type);

    //need to comment
    data.append('brand_sub_amount', this.state.amounter);

    data.append('upfront_brand_sub_amount', this.state.upfront_amounter);
    data.append('post_brand_sub_amount', this.state.post_amounter);

    //need to comment
    if (this.state.define_max == false) {
      data.append('max_cashback', -1);
    } else {
      data.append('max_cashback', this.state.max_amounter);
    }

    if (this.state.upfront_define_max == false) {
      data.append('upfront_max_cashback', this.state.upfront_max_amounter);
    } else {
      data.append('upfront_max_cashback', this.state.upfront_max_amounter);
    }

    if (this.state.post_define_max == false) {
      data.append('post_max_cashback', this.state.post_max_amounter);
    } else {
      data.append('post_max_cashback', this.state.post_max_amounter);
    }

    // need to comment
    if (this.state.pre_or_post == 'pre') {
      data.append('is_upfront', 1);
    }
    // need to comment
    else {
      data.append('is_upfront', 0);
    }

    if (this.state.emi_type == '0') {
      data.append('emi_type', 0);
    } else {
      data.append('emi_type', 1);
    }
    data.append('brand_emi', this.state.brand_emi);
    data.append('bank_emi', this.state.bank_emi);
    data.append('merchant_emi', this.state.merchant_emi);
    data.append('innoviti_emi', this.state.innoviti_emi);
    data.append('customer_emi', this.state.customer_emi);

    // need to comment
    data.append('brand_cb', this.state.brand_cb);
    data.append('bank_cb', this.state.bank_cb);
    data.append('merchant_cb', this.state.merchant_cb);
    data.append('innoviti_cb', this.state.innoviti_cb);
    data.append('customer_cb', this.state.customer_cb);

    //post cashback
    data.append('upfront_brand_cb', this.state.upfront_brand_cb);
    data.append('upfront_bank_cb', this.state.upfront_bank_cb);
    data.append('upfront_merchant_cb', this.state.upfront_merchant_cb);
    data.append('upfront_innoviti_cb', this.state.upfront_innoviti_cb);
    data.append('upfront_customer_cb', this.state.upfront_customer_cb);

    // upfront cashback
    data.append('post_brand_cb', this.state.post_brand_cb);
    data.append('post_bank_cb', this.state.post_bank_cb);
    data.append('post_merchant_cb', this.state.post_merchant_cb);
    data.append('post_innoviti_cb', this.state.post_innoviti_cb);
    data.append('post_customer_cb', this.state.post_customer_cb);

    data.append('processing_fees', this.state.processing_fees);
    data.append('pre_or_post', this.state.selected_bank_pre);
    data.append('tid', this.state.tid);
    data.append('scheme_type', this.state.scheme_type);
    data.append('additional_contains', this.state.additional_contains);
    data.append('additional_terms_conditions', this.state.additional_terms_conditions);
    data.append('low_cost_subvention', this.state.low_cost_subvention);
    data.append('interest_rate', this.state.interest_rate);
    data.append('start_date', this.state.start_date);
    data.append('end_date', this.state.end_date);
    data.append('flexipay', locFlexipay);
    data.append('bank_max_per_cb', this.state.bank_max_limit_on_cashback);
    data.append('bank_cb_per', this.state.bank_share_of_tx);
    data.append('is_variable', this.state.subvention_participants);


    axios.post(config.get('API_URL') + '/brandemi/check_duplicate_schemes', data, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      },
    })
      .then(response => {
        if (response.data === true) {
          this.handleNotificationClick("tr", 3, "Scheme already exists with the same parameters.");
          this.setState({
            isSubmit: false,
            loading: false
          });
          this.resetCooldown();
        }
        else {

          axios.post(config.get('API_URL') + "/brandemi/create_new_scheme_new_bankemi", data, {
            headers: {
              Authorization: ` ${localStorage.usertoken}`
            }
          })
            .then(res => {
              if (res.status == 200) {
                this.handleNotificationClick("tr", 1, `Scheme "${this.state.scheme_name}" added successfully`);
                this.resetCooldown();
                this.setState({
                  isSubmit: false,
                  loading: false
                });
              }
              else {
                this.handleNotificationClick("tr", 3, "API error");
                this.resetCooldown();
                this.setState({
                  isSubmit: false,
                  loading: false
                });
              }
            })
            .catch(err => {
              this.handleNotificationClick("tr", 3, "Something Wrong!");
              this.resetCooldown();
              this.setState({
                isSubmit: false,
                loading: false
              })
            });
          }
        })
      .catch(error => {
          this.handleNotificationClick("tr", 3, "Error finding unique scheme name");
          this.resetCooldown();
          this.setState({
            loading: false
          })
        });
  }


  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  openInstructions() {
    this.setState({
      open_instructions: !this.state.open_instructions
    });

  }

  handleChange(checked) {
    console.log(this.state.checked);
    this.setState({
      checked
    });
  }

  // In the updateBankValues method
  updateBankValues = (valuer) => {
    const isUPI = this.isUPIBank(valuer.value);

    const newState = {
      selected_bank: valuer.value,
      selected_bank_code: valuer.value1,
      selected_bank_pre: valuer.value2,
    };

    if (isUPI) {
      // UPI-specific rules
      newState.scheme_type = 'brandemi';
      newState.is_emi = false;
      newState.is_cashback = true;
      newState.is_upfront_cashback = true;
      newState.is_post_cashback = false;
      newState.emi_type = '0';
      newState.upfront_cashback_type = 'flat';
      newState.selected_tenure = 1;

    } else {
      newState.is_emi = true;
      newState.is_cashback = false;
      newState.is_upfront_cashback = false;
      newState.is_post_cashback = false;
      newState.selected_tenure = null;
    }

    this.setState(newState, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  updateTenure = (valuer) => {
    this.setState({
      selected_tenure: valuer.value,
      selected_tenure_code: valuer.value1
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  updateDefineMaxCashback = (valuer) => {
    this.setState({
      define_max: valuer.target.checked,
    });
  };

  ufrontUpdateDefineMaxCashback = (valuer) => {
    this.setState({
      upfront_define_max: valuer.target.checked,
    });
  };

  postUpdateDefineMaxCashback = (valuer) => {
    this.setState({
      post_define_max: valuer.target.checked,
    });
  };

  updateEMI(checked) {
    this.setState({
      is_emi: checked,
      low_cost_subvention: ''
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  }

  updateCashback(checked) {
    this.setState({
      is_cashback: checked,
      is_upfront_cashback: checked,
      // is_post_cashback: checked,
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  }

  // updateCashbackType = e => {
  //   const { name, value } = e.target;
  //   this.setState({
  //     [name]: value
  //   }, () => {
  //     const newSchemeName = this.generateSchemeName();
  //     if (newSchemeName !== 'Scheme name will be auto-generated') {
  //       this.setState({ scheme_name: newSchemeName });
  //     }
  //   });
  // }

  updateCashbackType = e => {
    const { name, value } = e.target;
    const newState = {
      [name]: value
    };



    this.setState(newState, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  }

  updatePostCashbackType = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  updateEmiType = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      low_cost_subvention: ''
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  updateSchemeType = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  updatePreOrPost = e => {
    const { name, value } = e.target;
    let valueName = ''
    if (value === 'pre') {
      valueName = 'is_upfront_cashback'
      this.setState({
        is_post_cashback: false,
        post_brand_cb: 100,
        post_bank_cb: 0,
        post_amounter: '',
      });
    }
    if (value === 'post') {
      valueName = 'is_post_cashback'
      this.setState({
        is_upfront_cashback: false,
        upfront_brand_cb: 100,
        upfront_bank_cb: 0,
        upfront_amounter: '',
      });

    }

    this.setState(prevState => ({
      [name]: value,
      [valueName]: !prevState[valueName],
    }), () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  }

  // Add a method to handle upfront cashback amount change
  handleUpfrontAmountChange = (e) => {
    let { upfront_amounter } = this.state;
    upfront_amounter = e.target.value;
    this.setState({
      upfront_amounter: upfront_amounter,

    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    });
  };

  handlePostAmountChange = (e) => {
    let { post_amounter } = this.state;
    post_amounter = e.target.value;
    this.setState({
      post_amounter: post_amounter
    }, () => {
      const newSchemeName = this.generateSchemeName();
      if (newSchemeName !== 'Scheme name will be auto-generated') {
        this.setState({ scheme_name: newSchemeName });
      }
    })
  }

  // createScheme = () => {

  //    if (this.state.cooldownRemaining > 0) {
  //     this.handleNotificationClick("tr", 2, `Please wait ${this.state.cooldownRemaining} seconds before creating another scheme`);
  //     return;
  //   }

  //   if (this.state.isSubmit) {
  //     this.handleNotificationClick("tr", 2, "Please wait, scheme is being created...");
  //     return;
  //   }

  //   if(!this.state.canCreateScheme){
  //     this.handleNotificationClick("tr", 3, "You don't have permission to create scheme.");
  //     return;
  //   }

  //   let vala = this.state.scheme_name;
  //   let kill = 0;

  //   this.startCooldown(5);

  //   this.setState({
  //     loading: true,
  //     isSubmit: true
  //   });

  //   //need comment
  //   const in_amounter = Number(this.state.amounter);
  //   const in_max_amounter = Number(this.state.max_amounter);

  //   const upfront_in_amounter = Number(this.state.upfront_amounter);
  //   const upfront_in_max_amounter = Number(this.state.upfront_max_amounter);

  //   const post_in_amounter = Number(this.state.post_amounter);
  //   const post_in_max_amounter = Number(this.state.post_max_amounter);


  //   console.log(isNaN(this.state.amounter));
  //   console.log(isNaN(this.state.max_amounter));
  //   console.log(in_amounter);
  //   console.log(in_max_amounter);
  //   const token = localStorage.usertoken;
  //   const decoded = jwt_decode(token);
  //   if (this.state.scheme_name === '' || this.state.scheme_name === null || this.state.scheme_name === 'Scheme name will be auto-generated') {
  //     this.handleNotificationClick("tr", 3, "Scheme name is required. Please fill all required fields.");
  //     kill = 1;
  //   }
  //   if (this.state.start_date > this.state.end_date) {
  //     this.handleNotificationClick("tr", 3, "Invalid date range");
  //     kill = 1;
  //   } else if (vala.length > 40) {
  //     this.handleNotificationClick("tr", 3, "Max 40 chars for scheme name");
  //     kill = 1;
  //   }
  //   if (this.state.selected_bank == null) {
  //     this.handleNotificationClick("tr", 3, "Select bank name");
  //     kill = 1;
  //   }
  //   if (!this.state.is_emi && !this.state.is_cashback) {
  //     this.handleNotificationClick("tr", 3, "Select atleast one of Avail Zero Cost EMI or Avail Cashback");
  //     kill = 1;
  //   }
  //   if (this.state.is_emi && this.state.selected_tenure == null) {
  //     this.handleNotificationClick("tr", 3, "Select emi tenure");
  //     kill = 1;
  //   }
  //   if (isNaN(this.state.processing_fees)) {
  //     this.handleNotificationClick("tr", 3, "Enter valid processing fees");
  //     kill = 1;
  //   }
  //   if (isNaN(this.state.interest_rate)) {
  //     this.handleNotificationClick("tr", 3, "Enter valid interest rate");
  //     kill = 1;
  //   } else {
  //     var addup1 = Number(this.state.interest_rate);
  //     if (addup1 == 0 || addup1 == 100) {
  //       this.handleNotificationClick("tr", 3, "Enter valid interest rate");
  //       kill = 1;
  //     }
  //   }
  //   if (this.state.tid.length > 40) {
  //     this.handleNotificationClick("tr", 3, "Max 40 chars for TID");
  //     kill = 1;
  //   }
  //   if ((this.state.tid.length == 0 || this.state.tid == null) && this.state.user_type == 'admin') {
  //     this.handleNotificationClick("tr", 3, "TID is compulsory");
  //     kill = 1;
  //   }
  //   if (this.state.additional_contains.length > 250) {
  //     this.handleNotificationClick("tr", 3, "Max 250 chars for Charge Slip Additional Contains");
  //     kill = 1;
  //   }
  //   if (this.state.additional_terms_conditions.length > 500) {
  //     this.handleNotificationClick("tr", 3, "Max 500 chars for Additional T&C");
  //     kill = 1;
  //   }

  //   if (this.state.is_emi == true) {
  //     if (isNaN(this.state.innoviti_emi) || isNaN(this.state.merchant_emi) || isNaN(this.state.bank_emi) || isNaN(this.state.brand_emi) || isNaN(this.state.customer_emi)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
  //       kill = 1;
  //     } else {
  //       var addup = Number(this.state.innoviti_emi) + Number(this.state.merchant_emi) + Number(this.state.bank_emi) + Number(this.state.brand_emi) + Number(this.state.customer_emi);
  //       console.log(addup);
  //       if (addup == 99.99 || addup == 100 || addup == 100.00) {

  //       } else {
  //         this.handleNotificationClick("tr", 3, "Zero cost EMI subventions should add up to 100");
  //         kill = 1;
  //       }
  //     }
  //     if (this.state.emi_type == '1') {
  //       if (isNaN(this.state.low_cost_subvention) || this.state.low_cost_subvention == '' || this.state.low_cost_subvention == null) {
  //         this.handleNotificationClick("tr", 3, "Enter valid low cost EMI subvention");
  //         kill = 1;
  //       } else if (Number(this.state.low_cost_subvention) >= 99) {
  //         this.handleNotificationClick("tr", 3, "Enter valid low cost EMI subvention value");
  //         kill = 1;
  //       }
  //     }
  //   }

  //   if (this.state.is_cashback == true) {
  //     if (this.state.is_upfront_cashback == true) {
  //       if (isNaN(this.state.upfront_innoviti_cb) || isNaN(this.state.upfront_merchant_cb) || isNaN(this.state.upfront_bank_cb) || isNaN(this.state.upfront_brand_cb) || isNaN(this.state.upfront_customer_cb)) {
  //         this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
  //         kill = 1;
  //       } else {
  //         var addup = Number(this.state.upfront_bank_cb) + Number(this.state.upfront_brand_cb); //Number(this.state.upfront_innoviti_cb) + Number(this.state.upfront_merchant_cb) +  + Number(this.state.upfront_customer_cb)
  //         if (addup == 99.99 || addup == 100.00 || addup == 100) {

  //         } else {
  //           this.handleNotificationClick("tr", 3, "Cashback subventions should add up to 100");
  //           kill = 1;
  //         }
  //       }
  //     }

  //     // post cashback validation
  //     if (this.state.is_post_cashback == true) {
  //       if (isNaN(this.state.post_innoviti_cb) || isNaN(this.state.post_merchant_cb) || isNaN(this.state.post_bank_cb) || isNaN(this.state.post_brand_cb) || isNaN(this.state.post_customer_cb)) {
  //         this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
  //         kill = 1;
  //       } else {
  //         var addup = Number(this.state.post_bank_cb) + Number(this.state.post_brand_cb); //Number(this.state.post_innoviti_cb) + Number(this.state.post_merchant_cb) + + Number(this.state.post_customer_cb);
  //         if (addup == 99.99 || addup == 100.00 || addup == 100) {

  //         } else {
  //           this.handleNotificationClick("tr", 3, "Cashback subventions should add up to 100");
  //           kill = 1;
  //         }
  //       }
  //     }
  //   }

  //   //need to comment
  //   // if (this.state.is_cashback && this.state.cashback_type === 'flat') {
  //   //     if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)) {
  //   //         this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
  //   //         kill = 1;
  //   //     }
  //   //     else if (isNaN(this.state.amounter)) {
  //   //         this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
  //   //         kill = 1;
  //   //     }
  //   //     else if (!isNaN(this.state.amounter) && in_amounter <= 0) {
  //   //         this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
  //   //         kill = 1;
  //   //     }
  //   // }


  //   // upfront
  //   if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'flat') {
  //     if (this.state.upfront_amounter === '' || this.state.upfront_amounter === null || isNaN(this.state.upfront_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid upfront cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.upfront_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter upfront cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid upfront cashback amount");
  //       kill = 1;
  //     }
  //   }


  //   // post
  //   if (this.state.is_post_cashback && this.state.post_cashback_type === 'flat') {
  //     if (this.state.post_amounter === '' || this.state.post_amounter === null || isNaN(this.state.post_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid post cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.post_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter post cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.post_amounter) && post_in_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid post cashback amount");
  //       kill = 1;
  //     }
  //   }


  //   //need to comment
  //   if (this.state.is_cashback && this.state.cashback_type === 'percent') {
  //     if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
  //       kill = 1;
  //     } else if (isNaN(this.state.amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.amounter) && in_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
  //       kill = 1;
  //     } else if (!isNaN(this.state.amounter) && in_amounter >= 100) {
  //       this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
  //       kill = 1;
  //     }
  //   }


  //   //upfront
  //   if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'percent') {
  //     if (this.state.upfront_amounter === '' || this.state.upfront_amounter === null || isNaN(this.state.upfront_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid upfront cashback percentage");
  //       kill = 1;
  //     }/*else if (this.state.upfront_max_amounter === '' || this.state.upfront_max_amounter === null || isNaN(this.state.upfront_max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid upfront  max cashback ");
  //       kill = 1;
  //       }*/ else if (!isNaN(this.state.upfront_max_amounter) && upfront_in_amounter < 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid upfront Max cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.upfront_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter upfront cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid upfront cashback percentage");
  //       kill = 1;
  //     } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter >= 100) {
  //       this.handleNotificationClick("tr", 3, "Upfront cashback percent cannot be greater than 99");
  //       kill = 1;
  //     }
  //   }


  //   //post
  //   if (this.state.is_post_cashback && this.state.post_cashback_type === 'percent') {
  //     if (this.state.post_amounter === '' || this.state.post_amounter === null || isNaN(this.state.post_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
  //       kill = 1;
  //     }/*else if (this.state.post_max_amounter === '' || this.state.post_max_amounter === null || isNaN(this.state.post_max_amounter )) {
  //       this.handleNotificationClick("tr", 3, "Enter valid post  max cashback ");
  //       kill = 1;
  //       }*/ else if (!isNaN(this.state.post_max_amounter) && post_in_amounter < 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid post Max cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.post_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.post_amounter) && post_in_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
  //       kill = 1;
  //     } else if (!isNaN(this.state.post_amounter) && post_in_amounter >= 100) {
  //       this.handleNotificationClick("tr", 3, "Post cashback percent cannot be greater than 99");
  //       kill = 1;
  //     }
  //   }


  //   // need to comment
  //   if (this.state.is_cashback && this.state.cashback_type === 'percent' && this.state.define_max === true) {
  //     if (this.state.max_amounter == '' || this.state.max_amounter == null || isNaN(this.state.max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.max_amounter) && in_max_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
  //       kill = 1;
  //     }
  //   }


  //   //upfront
  //   if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'percent' && this.state.upfront_define_max === true) {
  //     if (this.state.upfront_max_amounter == '' || this.state.upfront_max_amounter == null || isNaN(this.state.upfront_max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid maximum upfront cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.upfront_max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter max upfront cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.upfront_max_amounter) && upfront_in_max_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid max upfront cashback amount");
  //       kill = 1;
  //     }
  //   }


  //   //post
  //   if (this.state.is_post_cashback && this.state.post_cashback_type === 'percent' && this.state.post_define_max === true) {
  //     if (this.state.post_max_amounter == '' || this.state.post_max_amounter == null || isNaN(this.state.post_max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter valid maximum post cashback amount");
  //       kill = 1;
  //     } else if (isNaN(this.state.post_max_amounter)) {
  //       this.handleNotificationClick("tr", 3, "Enter max post cashback value as digits");
  //       kill = 1;
  //     } else if (!isNaN(this.state.post_max_amounter) && post_in_max_amounter <= 0) {
  //       this.handleNotificationClick("tr", 3, "Enter valid max post cashback amount");
  //       kill = 1;
  //     }
  //   }

  //   // TID length validation based on bank + emi_type
  //   if (this.state.emi_type === '1') {
  //     if (this.state.selected_bank === 'ISB0000000009' && this.state.tid.length !== 11) {
  //       this.handleNotificationClick("tr", 3, "For bank SBI, TID must be 11 characters when EMI Type is LOW COST");
  //       kill = 1;
  //     }
  //     if (this.state.selected_bank === 'ISB0000000001' && this.state.tid.length !== 4) {
  //       this.handleNotificationClick("tr", 3, "For bank HDFC, TID must be 4 characters when EMI type is LOW COST");
  //       kill = 1;
  //     }
  //   }

  //   if (this.state.updatedRoi === "" || this.state.updatedEffectiveRoi === "") {
  //     this.handleNotificationClick("tr", 3, "Bank Scheme not configured for selected Bank-Brand-Tenure, kindly create bank scheme");
  //     kill = 1;
  //   }

  //   if (kill !== 0) {
  //     this.resetCooldown(); // Add this line
  //     this.setState({
  //       loading: false,
  //       isSubmit: false 
  //     });
  //     return;
  //   }

  //   if (kill == 0) {
  //     if (((decoded.userGroup == 1 && (this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi')) || (decoded.userGroup == '1' && (this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi'))) && (this.state.selected_party == null || this.state.selected_party_type == null)) {
  //       this.handleNotificationClick("tr", 3, "Please select a party");
  //       this.setState({
  //         loading: false,
  //         isSubmit: false
  //       })
  //     } else {
  //       this.getDuplicate();
  //     }
  //   } else {
  //     this.setState({
  //       loading: false,
  //       isSubmit: false 
  //     })
  //   }
  // }

  createScheme = () => {
    // CRITICAL: Check cooldown FIRST and prevent any execution
    if (this.state.cooldownRemaining > 0) {
      this.handleNotificationClick("tr", 2, `Please wait ${this.state.cooldownRemaining} seconds before creating another scheme`);
      return;
    }

    // Check if already submitting
    if (this.state.isSubmit) {
      this.handleNotificationClick("tr", 2, "Please wait, scheme is being created...");
      return;
    }

    // Check permission
    if (!this.state.canCreateScheme) {
      this.handleNotificationClick("tr", 3, "You don't have permission to create scheme.");
      return;
    }

    let vala = this.state.scheme_name;
    let kill = 0;

    // Set loading and submit states IMMEDIATELY
    // This prevents multiple clicks immediately
    this.setState({
      loading: true,
      isSubmit: true
    });

    // Start cooldown IMMEDIATELY after setting state
    this.startCooldown(5);

    //need comment
    const in_amounter = Number(this.state.amounter);
    const in_max_amounter = Number(this.state.max_amounter);

    const upfront_in_amounter = Number(this.state.upfront_amounter);
    const upfront_in_max_amounter = Number(this.state.upfront_max_amounter);

    const post_in_amounter = Number(this.state.post_amounter);
    const post_in_max_amounter = Number(this.state.post_max_amounter);

    console.log(isNaN(this.state.amounter));
    console.log(isNaN(this.state.max_amounter));
    console.log(in_amounter);
    console.log(in_max_amounter);
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);

    if (this.state.scheme_name === '' || this.state.scheme_name === null || this.state.scheme_name === 'Scheme name will be auto-generated') {
      this.handleNotificationClick("tr", 3, "Scheme name is required. Please fill all required fields.");
      kill = 1;
    }
    if (this.state.start_date > this.state.end_date) {
      this.handleNotificationClick("tr", 3, "Invalid date range");
      kill = 1;
    } else if (vala.length > 40) {
      this.handleNotificationClick("tr", 3, "Max 40 chars for scheme name");
      kill = 1;
    }
    if (this.state.selected_bank == null) {
      this.handleNotificationClick("tr", 3, "Select bank name");
      kill = 1;
    }
    if (!this.state.is_emi && !this.state.is_cashback) {
      this.handleNotificationClick("tr", 3, "Select atleast one of Avail Zero Cost EMI or Avail Cashback");
      kill = 1;
    }
    if (this.state.is_emi && this.state.selected_tenure == null) {
      this.handleNotificationClick("tr", 3, "Select emi tenure");
      kill = 1;
    }
    if (isNaN(this.state.processing_fees)) {
      this.handleNotificationClick("tr", 3, "Enter valid processing fees");
      kill = 1;
    }
    if (isNaN(this.state.interest_rate)) {
      this.handleNotificationClick("tr", 3, "Enter valid interest rate");
      kill = 1;
    } else {
      var addup1 = Number(this.state.interest_rate);
      if (addup1 == 0 || addup1 == 100) {
        this.handleNotificationClick("tr", 3, "Enter valid interest rate");
        kill = 1;
      }
    }
    if (this.state.tid.length > 40) {
      this.handleNotificationClick("tr", 3, "Max 40 chars for TID");
      kill = 1;
    }
    if ((this.state.tid.length == 0 || this.state.tid == null) && this.state.user_type == 'admin') {
      this.handleNotificationClick("tr", 3, "TID is compulsory");
      kill = 1;
    }
    if (this.state.additional_contains.length > 250) {
      this.handleNotificationClick("tr", 3, "Max 250 chars for Charge Slip Additional Contains");
      kill = 1;
    }
    if (this.state.additional_terms_conditions.length > 500) {
      this.handleNotificationClick("tr", 3, "Max 500 chars for Additional T&C");
      kill = 1;
    }

    if (this.state.is_emi == true) {
      if (isNaN(this.state.innoviti_emi) || isNaN(this.state.merchant_emi) || isNaN(this.state.bank_emi) || isNaN(this.state.brand_emi) || isNaN(this.state.customer_emi)) {
        this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
        kill = 1;
      } else {
        var addup = Number(this.state.innoviti_emi) + Number(this.state.merchant_emi) + Number(this.state.bank_emi) + Number(this.state.brand_emi) + Number(this.state.customer_emi);
        console.log(addup);
        if (addup == 99.99 || addup == 100 || addup == 100.00) {

        } else {
          this.handleNotificationClick("tr", 3, "Zero cost EMI subventions should add up to 100");
          kill = 1;
        }
      }
      if (this.state.emi_type == '1') {
        if (isNaN(this.state.low_cost_subvention) || this.state.low_cost_subvention == '' || this.state.low_cost_subvention == null) {
          this.handleNotificationClick("tr", 3, "Enter valid low cost EMI subvention");
          kill = 1;
        } else if (Number(this.state.low_cost_subvention) >= 99) {
          this.handleNotificationClick("tr", 3, "Enter valid low cost EMI subvention value");
          kill = 1;
        }
      }
    }

    if (this.state.is_cashback == true) {
      if (this.state.is_upfront_cashback == true) {
        if (isNaN(this.state.upfront_innoviti_cb) || isNaN(this.state.upfront_merchant_cb) || isNaN(this.state.upfront_bank_cb) || isNaN(this.state.upfront_brand_cb) || isNaN(this.state.upfront_customer_cb)) {
          this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
          kill = 1;
        } else {
          var addup = Number(this.state.upfront_bank_cb) + Number(this.state.upfront_brand_cb);
          if (addup == 99.99 || addup == 100.00 || addup == 100) {

          } else {
            this.handleNotificationClick("tr", 3, "Cashback subventions should add up to 100");
            kill = 1;
          }
        }
      }

      // post cashback validation
      if (this.state.is_post_cashback == true) {
        if (isNaN(this.state.post_innoviti_cb) || isNaN(this.state.post_merchant_cb) || isNaN(this.state.post_bank_cb) || isNaN(this.state.post_brand_cb) || isNaN(this.state.post_customer_cb)) {
          this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
          kill = 1;
        } else {
          var addup = Number(this.state.post_bank_cb) + Number(this.state.post_brand_cb);
          if (addup == 99.99 || addup == 100.00 || addup == 100) {

          } else {
            this.handleNotificationClick("tr", 3, "Cashback subventions should add up to 100");
            kill = 1;
          }
        }
      }
    }

    // upfront
    if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'flat') {
      if (this.state.upfront_amounter === '' || this.state.upfront_amounter === null || isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront cashback amount");
        kill = 1;
      } else if (isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter upfront cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront cashback amount");
        kill = 1;
      }
    }

    // post
    if (this.state.is_post_cashback && this.state.post_cashback_type === 'flat') {
      if (this.state.post_amounter === '' || this.state.post_amounter === null || isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid post cashback amount");
        kill = 1;
      } else if (isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter post cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.post_amounter) && post_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid post cashback amount");
        kill = 1;
      }
    }

    //need to comment
    if (this.state.is_cashback && this.state.cashback_type === 'percent') {
      if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (isNaN(this.state.amounter)) {
        this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.amounter) && in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.amounter) && in_amounter >= 100) {
        this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
        kill = 1;
      }
    }

    //upfront
    if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'percent') {
      if (this.state.upfront_amounter === '' || this.state.upfront_amounter === null || isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.upfront_max_amounter) && upfront_in_amounter < 0) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront Max cashback amount");
        kill = 1;
      } else if (isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter upfront cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter >= 100) {
        this.handleNotificationClick("tr", 3, "Upfront cashback percent cannot be greater than 99");
        kill = 1;
      }
    }

    //post
    if (this.state.is_post_cashback && this.state.post_cashback_type === 'percent') {
      if (this.state.post_amounter === '' || this.state.post_amounter === null || isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.post_max_amounter) && post_in_amounter < 0) {
        this.handleNotificationClick("tr", 3, "Enter valid post Max cashback amount");
        kill = 1;
      } else if (isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.post_amounter) && post_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.post_amounter) && post_in_amounter >= 100) {
        this.handleNotificationClick("tr", 3, "Post cashback percent cannot be greater than 99");
        kill = 1;
      }
    }

    // need to comment
    if (this.state.is_cashback && this.state.cashback_type === 'percent' && this.state.define_max === true) {
      if (this.state.max_amounter == '' || this.state.max_amounter == null || isNaN(this.state.max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
        kill = 1;
      } else if (isNaN(this.state.max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.max_amounter) && in_max_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
        kill = 1;
      }
    }

    //upfront
    if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'percent' && this.state.upfront_define_max === true) {
      if (this.state.upfront_max_amounter == '' || this.state.upfront_max_amounter == null || isNaN(this.state.upfront_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid maximum upfront cashback amount");
        kill = 1;
      } else if (isNaN(this.state.upfront_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter max upfront cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.upfront_max_amounter) && upfront_in_max_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid max upfront cashback amount");
        kill = 1;
      }
    }

    //post
    if (this.state.is_post_cashback && this.state.post_cashback_type === 'percent' && this.state.post_define_max === true) {
      if (this.state.post_max_amounter == '' || this.state.post_max_amounter == null || isNaN(this.state.post_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid maximum post cashback amount");
        kill = 1;
      } else if (isNaN(this.state.post_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter max post cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.post_max_amounter) && post_in_max_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid max post cashback amount");
        kill = 1;
      }
    }

    // TID length validation based on bank + emi_type
    if (this.state.emi_type === '1') {
      if (this.state.selected_bank === 'ISB0000000009' && this.state.tid.length !== 11) {
        this.handleNotificationClick("tr", 3, "For bank SBI, TID must be 11 characters when EMI Type is LOW COST");
        kill = 1;
      }
      if (this.state.selected_bank === 'ISB0000000001' && this.state.tid.length !== 4) {
        this.handleNotificationClick("tr", 3, "For bank HDFC, TID must be 4 characters when EMI type is LOW COST");
        kill = 1;
      }
    }

    if (this.state.updatedRoi === "" || this.state.updatedEffectiveRoi === "") {
      this.handleNotificationClick("tr", 3, "Bank Scheme not configured for selected Bank-Brand-Tenure, kindly create bank scheme");
      kill = 1;
    }

    // IMPORTANT: If validation fails, reset everything
    if (kill !== 0) {
      this.resetCooldown(); // Reset cooldown timer
      this.setState({
        loading: false,
        isSubmit: false
      });
      return;
    }

    if (kill == 0) {
      if (((decoded.userGroup == 1 && (this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi')) || (decoded.userGroup == '1' && (this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi'))) && (this.state.selected_party == null || this.state.selected_party_type == null)) {
        this.handleNotificationClick("tr", 3, "Please select a party");
        this.resetCooldown(); // Reset cooldown
        this.setState({
          loading: false,
          isSubmit: false
        });
      } else {
        this.getDuplicate();
      }
    } else {
      this.resetCooldown(); // Reset cooldown
      this.setState({
        loading: false,
        isSubmit: false
      });
    }
  }


  uploadDropdownHandler = () => {
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    if (decoded.userGroup == 1 || decoded.userGroup == '1') {
      this.props.history.push('/admin/admin-new-schemes-list')
    } else {
      this.props.history.push('/admin/new-schemes-master')
    }
  }

  toggleCalculate = () => {
    var kill = 0;
    this.setState({
      loading: true
    });

    //need to comment
    const in_amounter = Number(this.state.amounter);
    const in_max_amounter = Number(this.state.max_amounter);


    const upfront_in_amounter = Number(this.state.upfront_amounter);
    const upfront_in_max_amounter = Number(this.state.upfront_max_amounter);

    const post_in_amounter = Number(this.state.post_amounter);
    const post_in_max_amounter = Number(this.state.post_max_amounter);


    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    if (this.state.scheme_type === 'bankemi') {
      this.handleNotificationClick("tr", 3, "Not applicable for BankEMI");
      kill = 1;
      return;
    }
    if (this.state.scheme_type === 'freeemi') {
      this.handleNotificationClick("tr", 3, "Not applicable for FreeEMI");
      kill = 1;
      return;
    }
    if (this.state.scheme_name === '' || this.state.scheme_name === null || this.state.scheme_name === 'Scheme name will be auto-generated') {
      this.handleNotificationClick("tr", 3, "Please fill all required fields to generate scheme name");
      kill = 1;
    }
    if (this.state.selected_bank == null) {
      this.handleNotificationClick("tr", 3, "Select bank name");
      kill = 1;
    }
    if (!this.state.is_emi && !this.state.is_cashback) {
      this.handleNotificationClick("tr", 3, "Select atleast one of Avail Zero Cost EMI or Avail Cashback");
      kill = 1;
    }
    if (this.state.is_emi && this.state.selected_tenure == null) {
      this.handleNotificationClick("tr", 3, "Select emi tenure");
      kill = 1;
    }
    if (isNaN(this.state.processing_fees)) {
      this.handleNotificationClick("tr", 3, "Enter valid processing fees");
      kill = 1;
    }


    // // need to comment
    // if (this.state.is_cashback && this.state.cashback_type === 'flat') {
    //     if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)) {
    //         this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
    //         kill = 1;
    //     }
    //     else if (isNaN(this.state.amounter)) {
    //         this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
    //         kill = 1;
    //     }
    //     else if (!isNaN(this.state.amounter) && in_amounter <= 0) {
    //         this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
    //         kill = 1;
    //     }
    // }


    //upfront
    if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'flat') {
      if (this.state.upfront_amounter === '' || this.state.upfront_amounter === null || isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront cashback amount");
        kill = 1;
      } else if (isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter upfront cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid upfront cashback amount");
        kill = 1;
      }
    }


    //post
    if (this.state.is_post_cashback && this.state.post_cashback_type === 'flat') {
      if (this.state.post_amounter === '' || this.state.post_amounter === null || isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid post cashback amount");
        kill = 1;
      } else if (isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter post cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.post_amounter) && post_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid post cashback amount");
        kill = 1;
      }
    }


    //need to comment
    if (this.state.is_cashback && this.state.cashback_type === 'percent') {
      if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (isNaN(this.state.amounter)) {
        this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.amounter) && in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.amounter) && in_amounter >= 100) {
        this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
        kill = 1;
      }
    }


    //upfront
    if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'percent') {
      if (this.state.upfront_amounter === '' || this.state.upfront_amounter === null || isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (isNaN(this.state.upfront_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.upfront_amounter) && upfront_in_amounter >= 100) {
        this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
        kill = 1;
      }
    }


    //post
    if (this.state.is_post_cashback && this.state.post_cashback_type === 'percent') {
      if (this.state.post_amounter === '' || this.state.post_amounter === null || isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (isNaN(this.state.post_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.post_amounter) && post_in_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
        kill = 1;
      } else if (!isNaN(this.state.post_amounter) && post_in_amounter >= 100) {
        this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
        kill = 1;
      }
    }


    //need to comment
    if (this.state.is_cashback && this.state.cashback_type === 'percent' && this.state.define_max === true) {
      if (this.state.max_amounter == '' || this.state.max_amounter == null || isNaN(this.state.max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
        kill = 1;
      } else if (isNaN(this.state.max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.max_amounter) && in_max_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
        kill = 1;
      }
    }


    //upfront
    if (this.state.is_upfront_cashback && this.state.upfront_cashback_type === 'percent' && this.state.upfront_define_max === true) {
      if (this.state.upfront_max_amounter == '' || this.state.upfront_max_amounter == null || isNaN(this.state.upfront_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
        kill = 1;
      } else if (isNaN(this.state.upfront_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.upfront_max_amounter) && upfront_in_max_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
        kill = 1;
      }
    }


    //post
    if (this.state.is_post_cashback && this.state.post_cashback_type === 'percent' && this.state.post_define_max === true) {
      if (this.state.post_max_amounter == '' || this.state.post_max_amounter == null || isNaN(this.state.post_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
        kill = 1;
      } else if (isNaN(this.state.post_max_amounter)) {
        this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
        kill = 1;
      } else if (!isNaN(this.state.post_max_amounter) && post_in_max_amounter <= 0) {
        this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
        kill = 1;
      }
    }


    if (kill == 0) {
      if (this.state.isCalculate == false && this.state.is_emi == true) {
        axios.post(config.get('API_URL') + '/brandemi/get_emi_values', {
          bank_code: this.state.selected_bank_code,
          tenure_code: this.state.selected_tenure_code
        },
          {
            headers: {
              Authorization: ` ${localStorage.usertoken}`
            }
          })
          .then(response => {
            console.log(response);
            response.data.map((values, index) => {
              this.setState({
                roi: values.roi,
                effective_roi: values.effective_roi,
                loading: false
              }, () =>
                this.setState({
                  isCalculate: !this.state.isCalculate
                })
              )
            });
          });
      } else {
        this.setState({
          isCalculate: !this.state.isCalculate
        })
      }
    }
    this.setState({
      loading: false
    });

  }
  updateSubventionParticipants = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    })

    if (value === 0) {
      this.setState({
        bank_max_limit_on_cashback: 0,
        bank_share_of_tx: 0,
      });
    }
    else{
      this.setState({
        post_brand_cb: 100,
		    post_merchant_cb: 0,
		    post_bank_cb: 0,
		    post_innoviti_cb: 0,
		    post_customer_cb: 0,
        upfront_brand_cb: 100,
		    upfront_merchant_cb: 0,
    		upfront_bank_cb: 0,
		    upfront_innoviti_cb: 0,
		    upfront_customer_cb: 0,
        brand_emi: 100,
     		merchant_emi: 0,
    		bank_emi: 0,
    		innoviti_emi: 0,
		    customer_emi: 0
      });
    }
  }
  onChangeInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { canCreateScheme } = this.state;
    const isUPI = this.isUPIBank(this.state.selected_bank);
    let to_display_party = "Select party";
    if (this.state.selected_party_type == "Brand") {
      to_display_party = "Select brand";
    }
    console.log(this.state.selected_party2);
    console.log(this.state.selected_party2);
    let party_render = this.state.party_options;
    let party_render_list = this.state.party_list;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    let show_bank_emi = () => {
      if (this.state.scheme_type == 'bankemi' || this.state.scheme_type == 'freeemi') {
        return (
          <div className="row top-margin-10">
            <div className="col-md-3">
              <Label>EMI Tenures (in Months)</Label>
              <Select name={"month_tenure2"}
                // defaultValue={this.state.selectedMerchValues}
                onChange={this.updateTenure.bind(this)}
                options={month_tenure_render}
                placeholder="Select tenure"
                isDisabled={!is_emi_render}
              // isClearable={true}
              />
            </div>
            {this.state.scheme_type != 'freeemi' ?
              <div>
                <div className="col-md-3">
                  <Label>Interest Rate</Label>
                  <Input id="interest_rate" disabled={!(this.state.scheme_type == 'bankemi')} className="maxheighter"
                    placeholder={"Enter interest rate"} value={this.state.interest_rate} onChange={(e) => {
                      let { interest_rate } = this.state;
                      interest_rate = e.target.value;
                      this.setState({
                        interest_rate: interest_rate
                      })
                    }} />
                </div>
              </div>
              : null}
            <div className=" col-sm-6 col-md-3 col-xs-12">
              <Label>Select start date</Label>
              <DatePicker
                dateFormat="dd-MM-yyyy"
                selected={Date.parse(this.state.start_date)}
                onChange={this.handleFromChange}
                minDate={new Date()}
              />
            </div>
            <div className="col-sm-6 col-md-3 col-xs-12">
              <Label>Select end date</Label>
              <DatePicker
                dateFormat="dd-MM-yyyy"
                selected={Date.parse(this.state.end_date)}
                onChange={this.handleToChange}
                minDate={new Date()}
              />
            </div>
          </div>
        )
      }
    }

    let processing_feeser = () => {
      if (decoded.userGroup == 1 || decoded.userGroup == '1') {
        return (
          <div>
            <div className="row top-margin-10">
              <div className="col-md-3">

                <Label>Processing Fees (on EMI)</Label>

                <div className="row">
                  <div className="col-md-12">
                    <Input id="processing_fees" className="maxheighter" value={this.state.processing_fees}
                      onChange={(e) => {
                        let { processing_fees } = this.state;
                        processing_fees = e.target.value;
                        this.setState({
                          processing_fees: processing_fees,
                          mapField2: false
                        })
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-3">

                <Label>TID</Label>

                <div className="row">
                  <div className="col-md-12">
                    <Input id="tid" className="maxheighter" value={this.state.tid} onChange={(e) => {
                      let { tid } = this.state;
                      tid = e.target.value.replace(/\s/g, "")
                      this.setState({
                        tid: tid,
                        mapField2: false
                      })
                    }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row top-margin-10">
              <div className="col-md-6">
                <FormGroup>
                  <Label for="exampleText">Charge Slip Additional Contains</Label>
                  <Input type="textarea" name="text_charge" value={this.state.additional_contains}
                    id="additional_contains" onChange={(e) => {
                      let { additional_contains } = this.state;
                      additional_contains = e.target.value;
                      additional_contains = additional_contains.replace(/[\r\n]+/g, ' ');
                      this.setState({
                        additional_contains: additional_contains,
                        mapField2: false
                      })
                    }}
                  />
                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Label for="exampleText">Additional T{'&'}C</Label>
                  <Input type="textarea" name="text_additional" value={this.state.additional_terms_conditions}
                    id="additional_terms_conditions" onChange={(e) => {
                      let { additional_terms_conditions } = this.state;
                      additional_terms_conditions = e.target.value;
                      this.setState({
                        additional_terms_conditions: additional_terms_conditions,
                        mapField2: false
                      })
                    }}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        )
      } else {
        return (<div></div>)
      }
    }

    let party_shower = () => {
      if (
        (decoded.userGroup == 1 && this.state.scheme_type !== 'bankemi' && this.state.scheme_type !== 'freeemi') ||
        (decoded.userGroup == '1' && this.state.scheme_type !== 'bankemi' && this.state.scheme_type !== 'freeemi')
      ) {
        return (
          <div className="row top-margin-10" style={{ display: this.state.enableDisablePartyType }}>
            <div className="col-md-3">
              <Label>Select party type</Label>
              <Select
                name="party_type"
                value={this.state.selected_party_type2}
                onChange={this.updatePartyType.bind(this)}
                options={party_render}
                placeholder="Select party type"
              />
            </div>
            <div className="col-md-3">
              <Label>{to_display_party}</Label>
              <Select
                name="party_name"
                value={this.state.selected_party2}
                onChange={this.updatePartyValue.bind(this)}
                options={party_render_list}
                placeholder="Select party"
              />
            </div>
            <div className="col-md-3">
              <Label>ROI</Label>
              <input
                type="text"
                className="form-control"
                value={this.state.roi || ""}
                readOnly
              />
            </div>
            <div className="col-md-3">
              <Label>Effective ROI</Label>
              <input
                type="text"
                className="form-control"
                value={this.state.effectiveRoi || ""}
                readOnly
              />
            </div>
          </div>
        );
      } else {
        return <div />;
      }
    };




    let bank_options_render = this.state.bank_options;
    let month_tenure_render = this.state.month_tenure;
    let val_to_insert = null;
    let val_holder = null;
    // upfront cashback
    let upfront_val_to_insert = null;
    let upfront_val_holder = null;

    // post cashback
    let post_val_to_insert = null;
    let post_val_holder = null;


    let val_share = 'Share (in %)';

    //need to comment
    if (this.state.cashback_type == 'flat') {
      val_to_insert = 'Cashback amount';
      val_holder = 'Enter amount';
    }

    // upfront cahsback
    if (this.state.upfront_cashback_type == 'flat') {
      upfront_val_to_insert = 'Upfront Cashback amount';
      upfront_val_holder = 'Upfront Enter amount';
    } else {
      upfront_val_to_insert = 'Upfront Cashback percentage';
      upfront_val_holder = 'Upfront Enter percentage';
    }

    // post cahsback
    if (this.state.post_cashback_type == 'flat') {
      post_val_to_insert = 'Post Cashback amount';
      post_val_holder = 'Post Enter amount';
    } else {
      post_val_to_insert = 'Post Cashback percentage';
      post_val_holder = 'Post Enter percentage';
    }


    let is_emi_render = (this.state.is_emi) ? true : false;
    let is_cashback_render = (this.state.is_cashback) ? true : false;
    let is_upfront_cashback_render = (this.state.is_upfront_cashback) ? true : false;
    let is_post_cashback_render = (this.state.is_post_cashback) ? true : false;
    let emi_type_zero = (this.state.emi_type === '0') ? true : false;
    let emi_type_low = (this.state.emi_type === '1') ? true : false;

    //need to comment
    let cashback_type_flat = (this.state.cashback_type === 'flat') ? true : false;
    let cashback_type_percent = (this.state.cashback_type === 'percent') ? true : false;


    let upfront_cashback_type_flat = (this.state.upfront_cashback_type === 'flat') ? true : false;
    let upfront_cashback_type_percent = (this.state.upfront_cashback_type === 'percent') ? true : false;

    let post_cashback_type_flat = (this.state.post_cashback_type === 'flat') ? true : false;
    let post_cashback_type_percent = (this.state.post_cashback_type === 'percent') ? true : false;
    let subvention_participants_standard = (this.state.subvention_participants === '0') ? true : false;
    let subvention_participants_variable = (this.state.subvention_participants === '1') ? true : false;

    let scheme_type_brand = (this.state.scheme_type === 'brandemi') ? true : false;
    let scheme_type_exclusive = (this.state.scheme_type === 'exclusiveemi') ? true : false;
    let scheme_type_bank = (this.state.scheme_type === 'bankemi') ? true : false;
    let scheme_type_free = (this.state.scheme_type === 'freeemi') ? true : false;
    let p_type_pre = (this.state.pre_or_post === 'pre') ? true : false;
    let p_type_post = (this.state.pre_or_post === 'post') ? true : false;

    //need to coment
    let checkboxer = (this.state.is_cashback && this.state.cashback_type == 'percent') ? true : false;

    //updront cashback
    let upfront_checkboxer = (this.state.is_upfront_cashback && this.state.upfront_cashback_type == 'percent') ? true : false;

    // post chashback
    let post_checkboxer = (this.state.is_post_cashback && this.state.post_cashback_type == 'percent') ? true : false;


    //need to comment
    let max_cashbacker = false;
    if (this.state.cashback_type != 'flat') {
      max_cashbacker = (this.state.is_cashback && this.state.define_max) ? true : false;
    }


    //upfront cashback
    let upfront_max_cashbacker = false;
    if (this.state.upfront_cashback_type != 'flat') {
      upfront_max_cashbacker = (this.state.is_upfront_cashback && this.state.upfront_define_max) ? true : false;
    }
    if (this.state.upfront_cashback_type == 'percent') {
      upfront_max_cashbacker = true
    }

    //post cashback
    let post_max_cashbacker = false;
    if (this.state.post_cashback_type != 'flat') {
      post_max_cashbacker = (this.state.is_post_cashback && this.state.post_define_max) ? true : false;
    }
    if (this.state.post_cashback_type == 'percent') {
      post_max_cashbacker = true
    }


    let merch_payback_amt = Number(this.state.txn_amount) * Number(this.state.effective_roi) / 100;
    let loan_amt = 0;
    if (this.state.selected_bank_pre == 'PRE') {
      loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
    } else {
      loan_amt = Number(this.state.txn_amount)
    }
    let trans_amount = Number(this.state.txn_amount)
    let rate = Number(this.state.roi) / 100; // one month interest
    let time = Number(this.state.selected_tenure); // one month period
    let pmt_val = 0;
    let total_amount = 0;

    function pmt(rate, nper, pv, fv, type) {
      console.log(rate);
      console.log(nper);
      console.log(pv);
      if (!fv) fv = 0;
      if (!type) type = 0;

      if (rate == 0) return -(pv + fv) / nper;

      var pvif = Math.pow(1 + rate, nper);
      var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

      if (type == 1) {
        pmt /= (1 + rate);
      }
      ;

      pmt_val = pmt.toFixed(2);
      total_amount = (pmt * time);
      pmt_val = pmt.toFixed(2);
      return pmt_val;
    }

    let emi = (Number(this.state.txn_amount) * rate * Math.pow(1 + rate, time)) / (Math.pow(1 + rate, time) - 1);

    let to_display_what = () => {
      if (this.state.is_emi == true && this.state.is_cashback == false) {
        console.log(this.state.selected_party2);
        return (
          <div className="card noneshadow bordercard">
            <div className="row">
              <div className="col-md-6">Brand:</div>
              <div className="col-md-6">{this.state.selected_party2[0].label}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Category:</div>
              <div className="col-md-6">XXXXXX</div>
            </div>
            <div className="row">
              <div className="col-md-6">Model:</div>
              <div className="col-md-6">XXXXXX</div>
            </div>
            <div className="row">
              <div className="col-md-6">Tenure:</div>
              <div className="col-md-6">{this.state.selected_tenure + " months"}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Card Issuer:</div>
              <div className="col-md-6">{this.state.selected_bank}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Transaction Amount:</div>
              <div className="col-md-6">₹ {Number(this.state.txn_amount).toFixed(2)}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Merchant Payback:</div>
              <div className="col-md-6">{Number(this.state.effective_roi) + " %"}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Merchant Payback Amount:</div>
              <div className="col-md-6">₹ {merch_payback_amt.toFixed(2)}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Loan Amount:</div>
              <div className="col-md-6">₹ {loan_amt.toFixed(2)}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Charges (P.A):</div>
              <div className="col-md-6">{Number(this.state.roi).toFixed(2) + " %"}</div>
            </div>
            <div className="row">
              <div className="col-md-6">EMI Amount:</div>
              <div className="col-md-6">₹ {pmt(rate / 12, time, -loan_amt, 0, 0)}</div>
            </div>
            <div className="row">
              <div className="col-md-6">Adv EMI:</div>
              <div className="col-md-6">0</div>
            </div>
            <div className="row">
              <div className="col-md-6">Total Amount with interest:</div>
              <div className="col-md-6">₹ {total_amount.toFixed(2)}</div>
            </div>
            <div className="row">
              <div className="col-md-6">EMI convenience fees:</div>
              <div className="col-md-6">₹ {Number(this.state.processing_fees).toFixed(2) + " + GST"}</div>
            </div>
          </div>
        )
      } else if (this.state.is_emi == true && this.state.is_cashback == true) {

        //need to comment
        let messager = '';

        let upfront_messager = '';
        let post_messager = '';


        //need to comment
        if (this.state.cashback_type == 'flat') {
          messager = "You are eligible for ₹" + this.state.amounter + " cashback.";
        } else if (this.state.cashback_type == 'percent' && this.state.define_max == false) {
          messager = "You are eligible for " + this.state.amounter + "% cashback.";
        } else if (this.state.cashback_type == 'percent' && this.state.define_max == true) {
          messager = "You are eligible for " + this.state.amounter + "% cashback upto ₹" + this.state.max_amounter;
        }


        //upfront
        if (this.state.upfront_cashback_type == 'flat') {
          upfront_messager = "You are eligible for ₹" + this.state.upfront_amounter + " cashback.";
        } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == false) {
          upfront_messager = "You are eligible for " + this.state.upfront_amounter + "% cashback.";
        } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == true) {
          upfront_messager = "You are eligible for " + this.state.upfront_amounter + "% cashback upto ₹" + this.state.upfront_max_amounter;
        }


        //post
        if (this.state.post_cashback_type == 'flat') {
          post_messager = "You are eligible for ₹" + this.state.post_amounter + " cashback.";
        } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == false) {
          post_messager = "You are eligible for " + this.state.post_amounter + "% cashback.";
        } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == true) {
          post_messager = "You are eligible for " + this.state.post_amounter + "% cashback upto ₹" + this.state.post_max_amounter;
        }


        let transa_amount = Number(this.state.txn_amount);
        let superb = 0;
        let merch_payback_amt = 0;
        let manu = 0;
        if (this.state.is_post_cashback == true) {    // (this.state.pre_or_post == 'post') {
          if (this.state.post_cashback_type == 'flat') {
            superb = Number(this.state.post_amounter) * 100 / Number(this.state.txn_amount);
            merch_payback_amt = Number(this.state.post_amounter);
            loan_amt = Number(this.state.txn_amount);
          } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == false) {
            superb = Number(this.state.post_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            loan_amt = Number(this.state.txn_amount);
          } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == true) {
            superb = Number(this.state.post_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            if (merch_payback_amt > this.state.post_max_amounter) {
              merch_payback_amt = Number(this.state.post_max_amounter);
            }
            loan_amt = Number(this.state.txn_amount);
          }
          return (
            <div className="card noshadow bordercard">

              <div className="row">
                <div className="col-md-6">Brand:</div>
                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Category:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Model:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Tenure:</div>
                <div className="col-md-6">{this.state.selected_tenure + " months"}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Card Issuer:</div>
                <div className="col-md-6">{this.state.selected_bank}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Transaction Amount:</div>
                <div className="col-md-6">₹ {Number(this.state.txn_amount).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Merchant Payback:</div>
                <div className="col-md-6">{this.state.effective_roi + "%"}</div>
                {/* <div className="col-md-6">{((merch_payback_amt*100)/(Number(this.state.txn_amount))).toFixed(2) + " %"}</div> */}
              </div>
              <div className="row">
                <div className="col-md-6">Merchant Payback Amount:</div>
                <div className="col-md-6">₹ {Number(merch_payback_amt).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Loan Amount:</div>
                <div className="col-md-6">₹ {Number(loan_amt).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Charges (P.A):</div>
                <div className="col-md-6">{Number(this.state.roi).toFixed(2) + " %"}</div>
              </div>
              <div className="row">
                <div className="col-md-6">EMI Amount:</div>
                <div className="col-md-6">₹ {pmt(rate / 12, time, -loan_amt, 0, 0)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Adv EMI:</div>
                <div className="col-md-6">0</div>
              </div>
              <div className="row">
                <div className="col-md-6">Total Amount with Interest:</div>
                <div className="col-md-6">₹ {Number(total_amount).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">EMI convenience fees:</div>
                <div className="col-md-6">₹ {Number(this.state.processing_fees).toFixed(2) + " + GST"}</div>
              </div>
              <div className="row">
                <div className="col-md-12">{messager}</div>
              </div>

            </div>
          )

        } else {

          if (this.state.upfront_cashback_type == 'flat') {
            transa_amount = trans_amount - Number(this.state.upfront_amounter);
            superb = Number(this.state.upfront_amounter) * 100 / Number(this.state.txn_amount);
            merch_payback_amt = Number(this.state.upfront_amounter);
            loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
          } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == false) {
            superb = Number(this.state.upfront_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            transa_amount = trans_amount - merch_payback_amt;
            loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
          } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == true) {
            superb = Number(this.state.upfront_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            if (merch_payback_amt > this.state.upfront_max_amounter) {
              merch_payback_amt = Number(this.state.upfront_max_amounter);
            }
            transa_amount = trans_amount - merch_payback_amt;
            loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
          }
          manu = loan_amt * Number(this.state.effective_roi) / 100;
          messager = '';
          let true_loan_amt = (loan_amt - manu);
          let manu1 = true_loan_amt * Number(this.state.effective_roi) / 100;
          true_loan_amt = true_loan_amt.toFixed(2);
          return (
            <div className="card noshadow bordercard">

              <div className="row">
                <div className="col-md-6">Brand:</div>
                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Category:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Model:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Tenure:</div>
                <div className="col-md-6">{this.state.selected_tenure + " months"}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Card Issuer:</div>
                <div className="col-md-6">{this.state.selected_bank}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Product Price:</div>
                <div className="col-md-6">₹ {Number(this.state.txn_amount).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Instant Discount Amount:</div>
                <div className="col-md-6">₹ {Number(merch_payback_amt).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Transaction Amount:</div>
                <div className="col-md-6">₹ {Number(loan_amt).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Manufacturer Cashback:</div>
                <div className="col-md-6">{this.state.effective_roi + "%"}</div>
                {/* <div className="col-md-6">{((merch_payback_amt*100)/(Number(this.state.txn_amount))).toFixed(2) + " %"}</div> */}
              </div>
              <div className="row">
                <div className="col-md-6">Manufacturer Cashback Amount:</div>
                <div className="col-md-6">₹ {Number(manu).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Loan Amount:</div>
                <div className="col-md-6">₹ {true_loan_amt}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Rate of Interest (P.A):</div>
                <div className="col-md-6">{Number(this.state.roi).toFixed(2) + " %"}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Interest Amount:</div>
                <div className="col-md-6">₹ {manu}</div>
              </div>
              <div className="row">
                <div className="col-md-6">EMI Amount:</div>
                <div className="col-md-6">₹ {pmt(rate / 12, time, -true_loan_amt, 0, 0)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">EMI convenience fees:</div>
                <div className="col-md-6">₹ {Number(this.state.processing_fees).toFixed(2) + " + GST"}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Advance EMI:</div>
                <div className="col-md-6">0</div>
              </div>
              <div className="row">
                <div className="col-md-6">Total Amount with interest:</div>
                <div className="col-md-6">₹ {Number(total_amount).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Base Amount:</div>
                <div className="col-md-6">₹ {Number(loan_amt).toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-12">{messager}</div>
              </div>

            </div>
          )
        }

      } else if (this.state.is_emi == false && this.state.is_cashback == true) {
        let messager = '';
        let transa_amount = Number(this.state.txn_amount);
        let superb = 0;
        let merch_payback_amt = 0;


        //need to comment
        if (this.state.cashback_type == 'flat') {
          messager = "You are eligible for ₹" + this.state.amounter + " cashback.";
        } else if (this.state.cashback_type == 'percent' && this.state.define_max == false) {
          messager = "You are eligible for " + this.state.amounter + "% cashback.";
        } else if (this.state.cashback_type == 'percent' && this.state.define_max == true) {
          messager = "You are eligible for " + this.state.amounter + "% cashback upto ₹" + this.state.max_amounter;
        }


        //upfront
        if (this.state.upfront_cashback_type == 'flat') {
          messager = "You are eligible for ₹" + this.state.upfront_amounter + " cashback.";
        } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == false) {
          messager = "You are eligible for " + this.state.upfront_amounter + "% cashback.";
        } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == true) {
          messager = "You are eligible for " + this.state.upfront_amounter + "% cashback upto ₹" + this.state.upfront_max_amounter;
        }

        //post
        if (this.state.post_cashback_type == 'flat') {
          messager = "You are eligible for ₹" + this.state.post_amounter + " cashback.";
        } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == false) {
          messager = "You are eligible for " + this.state.post_amounter + "% cashback.";
        } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == true) {
          messager = "You are eligible for " + this.state.post_amounter + "% cashback upto ₹" + this.state.post_max_amounter;
        }


        if (this.state.is_post_cashback == true) {    // (this.state.pre_or_post == 'post') {
          if (this.state.post_cashback_type == 'flat') {
            superb = Number(this.state.post_amounter) * 100 / Number(this.state.txn_amount);
            merch_payback_amt = Number(this.state.post_amounter);
          } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == false) {
            superb = Number(this.state.post_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
          } else if (this.state.post_cashback_type == 'percent' && this.state.post_define_max == true) {
            superb = Number(this.state.post_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            if (merch_payback_amt > this.state.post_max_amounter) {
              merch_payback_amt = Number(this.state.post_max_amounter);
            }
          }
          return (
            <div className="card noshadow bordercard ">
              <div className="row">
                <div className="col-md-6">Brand:</div>
                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Category:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Model:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Transaction Amount:</div>
                <div className="col-md-6">₹ {transa_amount.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Merchant Payback:</div>
                <div className="col-md-6">{superb.toFixed(2) + " %"}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Merchant Payback Amount:</div>
                <div className="col-md-6">₹ {merch_payback_amt.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-12">{messager}</div>
              </div>

            </div>
          )
        } else {
          if (this.state.upfront_cashback_type == 'flat') {
            transa_amount = trans_amount - Number(this.state.upfront_amounter);
            superb = Number(this.state.upfront_amounter) * 100 / Number(this.state.txn_amount);
            merch_payback_amt = Number(this.state.upfront_amounter);
          } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == false) {
            superb = Number(this.state.upfront_amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            transa_amount = trans_amount - merch_payback_amt;
          } else if (this.state.upfront_cashback_type == 'percent' && this.state.upfront_define_max == true) {
            superb = Number(this.state.amounter);
            merch_payback_amt = Number(this.state.txn_amount) * superb / 100;
            if (merch_payback_amt > this.state.upfront_max_amounter) {
              merch_payback_amt = this.state.upfront_max_amounter;
            }
            transa_amount = trans_amount - merch_payback_amt;
          }
          messager = '';
          return (
            <div className="card noshadow bordercard ">
              <div className="row">
                <div className="col-md-6">Brand:</div>
                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Category:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Model:</div>
                <div className="col-md-6">XXXXXX</div>
              </div>
              <div className="row">
                <div className="col-md-6">Card Issuer:</div>
                <div className="col-md-6">{this.state.selected_bank}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Product Price:</div>
                <div className="col-md-6">₹ {trans_amount.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Instant Discount:</div>
                <div className="col-md-6">₹ {merch_payback_amt.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Transaction Amount:</div>
                <div className="col-md-6">₹ {transa_amount.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-6">Base Amount:</div>
                <div className="col-md-6">₹ {transa_amount.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="col-md-12">{messager}</div>
              </div>

            </div>
          )
        }
      }
    }

    return (
      <div className="content longcontent">
        <CommonNavbar />
        <div className="container-fluid">

          <div className="card-query-builder top-pad-5">
            <NotificationSystem ref="notificationSystem" style={style} />
            <ReactTooltip />
            <Modal isOpen={this.state.isCalculate}
              toggle={this.toggleCalculate.bind(this)}
              size="lg"
            >
              <ModalBody>
                <div className="row">
                  <div className="col-xs-12 ">
                    <h4 className="modalh4">Scheme calculation for scheme: {this.state.scheme_name}</h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3 ">
                    <Label>Transaction Amount:</Label>
                    <Input id="reason" className="maxheighter" placeholder={"Enter transaction amount"}
                      value={this.state.txn_amount} onChange={(e) => {
                        let { txn_amount } = this.state;
                        txn_amount = e.target.value;
                        if ((e.target.value === '-1' || isNaN(e.target.value))) {
                          this.handleNotificationClick("tr", 3, "Insert valid transaction amount");
                        } else {
                          this.setState({
                            txn_amount: txn_amount
                          })
                        }
                      }} />
                  </div>
                  <div className="col-md-9">
                    {to_display_what()}
                  </div>

                </div>
                <ModalFooter>
                  <Button color="primary" className="btn btn-primary btn-capitalize"
                    onClick={this.toggleCalculate}>Cancel</Button>{' '}
                  {/* <Button color="secondary" className="btn-capitalize2" onClick={this.toggleDecampaignModel.bind(this)}>Cancel</Button> */}
                </ModalFooter>
              </ModalBody>
            </Modal>
            <div className="col-md-12">
              <div className="card">
                <div className='sweet-loading'>
                  <BeatLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#123abc'}
                    loading={this.state.loading}
                  />
                </div>
                <div className="header">

                  <h4 className="title pull-left">Create new bank scheme3</h4>
                  <button onClick={this.uploadDropdownHandler}
                    className="btn-primary nowhiter notwhiter btn-capitalize3 pull-right">Go back
                  </button>
                  <button onClick={this.toggleCalculate}
                    className="btn-primary nowhiter notwhiter btn-capitalize3 pull-right">Calculate
                  </button>
                </div>

                <div className="content">
                  <div className="container-fluid">
                    {party_shower()}
                    <div className="row top-margin-10">
                      <div className="col-md-3">
                        <Label>Select bank</Label>
                        <Select name={"bank_name"}
                          // defaultValue={this.state.selectedMerchValues}
                          onChange={this.updateBankValues.bind(this)}
                          options={bank_options_render}
                          placeholder="Select bank"
                        // isClearable={true}
                        />
                      </div>
                      <div className="col-md-3">
                        <Label>Scheme name</Label>
                        <Input
                          id="scheme_name"
                          className="maxheighter"
                          value={this.state.scheme_name}
                          placeholder="Scheme name will be auto-generated"
                          readOnly
                        />
                        <small className="text-muted">
                          Scheme name is auto-generated based on your selections
                        </small>
                      </div>
                      {this.state.user_type === 'admin' ?
                        <div className="col-md-6">
                          <Label>Scheme type</Label>
                          <div className="row">
                            <div className="col-md-12 top-pad-5">
                              <input className="radio-margin-8" type="radio" name="scheme_type" value="brandemi"
                                checked={scheme_type_brand}
                                onChange={this.updateSchemeType} disabled={isUPI} /> BrandEMI &nbsp;&nbsp;&nbsp;
                              <input className="radio-margin-8" type="radio" name="scheme_type" value="exclusiveemi"
                                checked={scheme_type_exclusive}
                                onChange={this.updateSchemeType} disabled={isUPI} /> ExclusiveEMI &nbsp;&nbsp;&nbsp;
                              <div style={{ display: this.state.enableDisablePartyType }}>
                                <input className="radio-margin-8" type="radio" name="scheme_type" value="bankemi"
                                  checked={scheme_type_bank}
                                  onChange={this.updateSchemeType} disabled={isUPI} /> BankEMI &nbsp;&nbsp;&nbsp;
                                <input className="radio-margin-8" type="radio" name="scheme_type" value="freeemi"
                                  checked={scheme_type_free}
                                  onChange={this.updateSchemeType} disabled={isUPI} /> FreeEMI
                              </div>
                              &nbsp;&nbsp;&nbsp;
                            </div>
                          </div>
                        </div>
                        : null}
                    </div>
                    {show_bank_emi()}
                    {this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi' ?
                      <div className="row top-margin-10">

                        <div className="col-md-3">

                          <Label>Avail EMI</Label>

                          <div className="row">
                            <div className="col-md-3">
                              <Switch className="react-switch" height={20} width={38} name="isEMI"
                                onChange={this.updateEMI.bind(this)} checked={is_emi_render} disabled={isUPI}></Switch>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <Label>EMI type</Label>
                          <div className="row">
                            <div className="col-md-12">
                              <input className="radio-margin-8" type="radio" name="emi_type" disabled={!is_emi_render || isUPI}
                                value="0" checked={emi_type_zero} onChange={this.updateEmiType} /> Zero
                              Cost &nbsp;&nbsp;&nbsp;
                              <input className="radio-margin-8" type="radio" name="emi_type" disabled={!is_emi_render || isUPI}
                                value="1" checked={emi_type_low} onChange={this.updateEmiType} /> Low
                              Cost &nbsp;&nbsp;&nbsp;
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <Label>EMI Tenures (in Months)</Label>
                          <Select name={"month_tenure"}
                            onChange={this.updateTenure.bind(this)}
                            options={month_tenure_render}
                            placeholder="Select tenure"
                            isDisabled={!is_emi_render} // Add || isUPI
                          // value={this.state.month_tenure}
                          />
                        </div>
                        <div className="col-md-3">
                          <Label>Low Cost EMI Subvention</Label>
                          <Input id="low_cost_subvention" disabled={!(is_emi_render && emi_type_low) || isUPI}
                            className="maxheighter" placeholder={"Enter subvention"}
                            value={this.state.low_cost_subvention} onChange={(e) => {
                              let { low_cost_subvention } = this.state;
                              low_cost_subvention = e.target.value;
                              this.setState({
                                low_cost_subvention: low_cost_subvention
                              }, () => {
                                // After state updates, regenerate the scheme name
                                const newSchemeName = this.generateSchemeName();
                                if (newSchemeName !== this.state.scheme_name && newSchemeName !== 'Scheme name will be auto-generated') {
                                  this.setState({ scheme_name: newSchemeName });
                                }
                              })
                            }} />

                        </div>

                      </div>
                      : null}
                    {this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi' ?
                      <div className="row top-margin-10">

                        <div className="col-md-3">

                          <Label>Avail Cashback</Label>

                          <div className="row">
                            <div className="col-md-3">
                              <Switch className="react-switch" height={20} width={38} name="isCashback"
                                onChange={this.updateCashback.bind(this)} checked={is_cashback_render}></Switch>
                            </div>
                            <div className="col-md-9">
                              <input id="pre" className="radio-margin-8" type="checkbox" name="pre_or_post"
                                disabled={!is_cashback_render} value="pre" checked={is_upfront_cashback_render}
                                onChange={this.updatePreOrPost} />Upfront &nbsp;&nbsp;&nbsp;
                            </div>
                            <div className="left-padding-7 top-padding-9">
                              <input id="post" className="radio-margin-8" type="checkbox" name="pre_or_post"
                                disabled={!is_cashback_render || isUPI} value="post" checked={is_post_cashback_render}
                                onChange={this.updatePreOrPost} />Post
                            </div>
                          </div>
                        </div>


                        <div className="col-md-3">

                          <div className="row">
                            <Label>Upfront Cashback type</Label>

                            <div className="row">
                              <div className="col-md-12">
                                <input className="radio-margin-8" type="radio" name="upfront_cashback_type"
                                  disabled={!is_upfront_cashback_render} value="flat"
                                  checked={upfront_cashback_type_flat}
                                  onChange={this.updateCashbackType} /> Flat &nbsp;&nbsp;&nbsp;
                                <input className="radio-margin-8" type="radio" name="upfront_cashback_type"
                                  disabled={!is_upfront_cashback_render} value="percent"
                                  checked={upfront_cashback_type_percent}
                                  onChange={this.updateCashbackType} /> Percentage &nbsp;&nbsp;&nbsp;
                              </div>
                            </div>

                          </div>

                          <div className="row top-padding-7">
                            <Label>Post Cashback type</Label>

                            <div className="row">
                              <div className="col-md-12">
                                <input className="radio-margin-8" type="radio" name="post_cashback_type"
                                  disabled={!is_post_cashback_render || isUPI} value="flat"
                                  checked={post_cashback_type_flat}
                                  onChange={this.updatePostCashbackType} /> Flat &nbsp;&nbsp;&nbsp;
                                <input className="radio-margin-8" type="radio" name="post_cashback_type"
                                  disabled={!is_post_cashback_render || isUPI} value="percent"
                                  checked={post_cashback_type_percent}
                                  onChange={this.updatePostCashbackType} /> Percentage &nbsp;&nbsp;&nbsp;
                              </div>
                            </div>

                          </div>


                        </div>


                        <div className="col-md-3">

                          <div className="row ">

                            <Label>{upfront_val_to_insert}</Label>
                            <Input
                              id="upfront_amounter"
                              className="maxheighter"
                              disabled={!is_upfront_cashback_render}
                              placeholder={upfront_val_holder}
                              value={this.state.upfront_amounter}
                              onChange={this.handleUpfrontAmountChange}
                            />
                            <br />
                            <br />


                          </div>


                          <div className="row">

                            <Label>{post_val_to_insert}</Label>
                            <Input id="post_amounter" className="maxheighter" disabled={!is_post_cashback_render || isUPI}
                              placeholder={post_val_holder} value={this.state.post_amounter} onChange={this.handlePostAmountChange} />
                            <br />

                          </div>
                        </div>


                        <div className="col-md-3">

                          <div className="row left-padding">

                            <Label>Upfront Maximum cashback amount</Label>
                            {/* <Input id="upfront_max_amounter" disabled={!upfront_max_cashbacker} className="maxheighter"
                              placeholder={"Enter amount"} value={this.state.upfront_max_amounter}
                              onChange={(e) => {
                                let { upfront_max_amounter } = this.state;
                                upfront_max_amounter = e.target.value;
                                this.setState({
                                  upfront_max_amounter: upfront_max_amounter
                                })
                              }} /> */}
                            <Input
                              id="upfront_max_amounter"
                              disabled={!upfront_max_cashbacker}
                              className="maxheighter"
                              placeholder={"Enter amount"}
                              value={this.state.upfront_max_amounter}
                              onChange={this.handleUpfrontMaxAmountChange}  // CHANGE THIS
                            />
                          </div>


                          <div className="row top-padding-5 left-padding">

                            <Label>Post Maximum cashback amount</Label>
                            <Input id="post_max_amounter" disabled={!post_max_cashbacker || isUPI} className="maxheighter"
                              placeholder={"Enter amount"} value={this.state.post_max_amounter} onChange={this.handlePostMaxAmountChange} />
                          </div>


                        </div>

                      </div>
                      : null}
                    {this.state.scheme_type != 'bankemi' && this.state.scheme_type != 'freeemi' ?
                      <div>
                        {/* Standard/Variable radio - DISABLE when UPI */}
                        <div className="row">
                          <input className="radio-margin-8" type="radio" name="subvention_participants"
                            value="0" checked={subvention_participants_standard} onChange={this.updateSubventionParticipants}
                            disabled={isUPI} />
                          Standard &nbsp;&nbsp;&nbsp;
                          <input className="radio-margin-8" type="radio" name="subvention_participants"
                            value="1" checked={subvention_participants_variable} onChange={this.updateSubventionParticipants}
                            disabled={isUPI} />
                          Variable &nbsp;&nbsp;&nbsp;
                        </div>

                        {this.state.subvention_participants === '0' ?
                          <div>
                            <div className="row top-margin-10">
                              <div className="col-md-3">
                                <Label>Subvention Participants</Label>
                              </div>
                            </div>
                            <div className="row top-margin-10">
                              <div className="col-md-2"></div>
                              <div className="col-md-2"><Label>Brand(%)</Label></div>
                              <div className="col-md-2"><Label>Merchant(%)</Label></div>
                              <div className="col-md-2"><Label>Bank(%)</Label></div>
                              <div className="col-md-2"><Label>Innoviti(%)</Label></div>
                              {this.state.user_type === 'admin' ? <div className="col-md-2"><Label>Customer(%)</Label></div> : null}
                            </div>

                            {/* Zero Cost EMI - SHOW but DISABLE when UPI */}
                            <div className="row top-margin-10">
                              <div className="col-md-2">
                                <Label>Zero Cost EMI</Label>
                              </div>
                              <div className="col-md-2">
                                <Input id="brand_emi" disabled={!is_emi_render || isUPI} className="maxheighter"
                                  placeholder={"Share (%)"} value={this.state.brand_emi} onChange={(e) => {
                                    let { brand_emi } = this.state;
                                    brand_emi = e.target.value;
                                    this.setState({
                                      brand_emi: brand_emi,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="merchant_emi" disabled={!is_emi_render || isUPI} className="maxheighter"
                                  placeholder={"Share (%)"} value={this.state.merchant_emi} onChange={(e) => {
                                    let { merchant_emi } = this.state;
                                    merchant_emi = e.target.value;
                                    this.setState({
                                      merchant_emi: merchant_emi,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="bank_emi" disabled={!is_emi_render || isUPI} className="maxheighter"
                                  placeholder={"Share (%)"} value={this.state.bank_emi} onChange={(e) => {
                                    let { bank_emi } = this.state;
                                    bank_emi = e.target.value;
                                    this.setState({
                                      bank_emi: bank_emi,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="innoviti_emi" disabled={!is_emi_render || isUPI} className="maxheighter"
                                  placeholder={"Share (%)"} value={this.state.innoviti_emi} onChange={(e) => {
                                    let { innoviti_emi } = this.state;
                                    innoviti_emi = e.target.value;
                                    this.setState({
                                      innoviti_emi: innoviti_emi,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              {this.state.user_type === 'admin' ? (
                                <div className="col-md-2">
                                  <Input id="customer_emi" disabled={!is_emi_render || isUPI} className="maxheighter"
                                    placeholder={"Share (%)"} value={this.state.customer_emi} onChange={(e) => {
                                      let { customer_emi } = this.state;
                                      customer_emi = e.target.value;
                                      this.setState({
                                        customer_emi: customer_emi,
                                        mapField2: false
                                      })
                                    }} />
                                </div>
                              ) : null}
                            </div>

                            {/* Upfront Cashback - ENABLED for UPI */}
                            <div className="row top-margin-10">
                              <div className="col-md-2">
                                <Label>Upfront Cashback</Label>
                              </div>
                              <div className="col-md-2">
                                <Input id="upfront_brand_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_upfront_cashback_render}
                                  placeholder={val_share}
                                  value={this.state.upfront_brand_cb} onChange={(e) => {
                                    let { upfront_brand_cb } = this.state;
                                    upfront_brand_cb = e.target.value;
                                    this.setState({
                                      upfront_brand_cb: upfront_brand_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="upfront_merchant_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_upfront_cashback_render}
                                  placeholder={val_share}
                                  value={this.state.upfront_merchant_cb} onChange={(e) => {
                                    let { upfront_merchant_cb } = this.state;
                                    upfront_merchant_cb = e.target.value;
                                    this.setState({
                                      upfront_merchant_cb: upfront_merchant_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="upfront_bank_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_upfront_cashback_render}
                                  placeholder={val_share}
                                  value={this.state.upfront_bank_cb} onChange={(e) => {
                                    let { upfront_bank_cb } = this.state;
                                    upfront_bank_cb = e.target.value;
                                    this.setState({
                                      upfront_bank_cb: upfront_bank_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="upfront_innoviti_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_upfront_cashback_render}
                                  placeholder={val_share}
                                  value={this.state.upfront_innoviti_cb} onChange={(e) => {
                                    let { upfront_innoviti_cb } = this.state;
                                    upfront_innoviti_cb = e.target.value;
                                    this.setState({
                                      upfront_innoviti_cb: upfront_innoviti_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              {this.state.user_type === 'admin' ? (
                                <div className="col-md-2">
                                  <Input id="upfront_customer_cb" className="maxheighter"
                                    disabled={!is_cashback_render || !is_upfront_cashback_render}
                                    placeholder={val_share} value={this.state.upfront_customer_cb} onChange={(e) => {
                                      let { upfront_customer_cb } = this.state;
                                      upfront_customer_cb = e.target.value;
                                      this.setState({
                                        upfront_customer_cb: upfront_customer_cb,
                                        mapField2: false
                                      })
                                    }} />
                                </div>
                              ) : null}
                            </div>

                            {/* Post Cashback - SHOW but DISABLE when UPI */}
                            <div className="row top-margin-10">
                              <div className="col-md-2">
                                <Label>Post Cashback</Label>
                              </div>
                              <div className="col-md-2">
                                <Input id="post_brand_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_post_cashback_render || isUPI}
                                  placeholder={val_share}
                                  value={this.state.post_brand_cb} onChange={(e) => {
                                    let { post_brand_cb } = this.state;
                                    post_brand_cb = e.target.value;
                                    this.setState({
                                      post_brand_cb: post_brand_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="post_merchant_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_post_cashback_render || isUPI}
                                  placeholder={val_share}
                                  value={this.state.post_merchant_cb} onChange={(e) => {
                                    let { post_merchant_cb } = this.state;
                                    post_merchant_cb = e.target.value;
                                    this.setState({
                                      post_merchant_cb: post_merchant_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="post_bank_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_post_cashback_render || isUPI}
                                  placeholder={val_share}
                                  value={this.state.post_bank_cb} onChange={(e) => {
                                    let { post_bank_cb } = this.state;
                                    post_bank_cb = e.target.value;
                                    this.setState({
                                      post_bank_cb: post_bank_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              <div className="col-md-2">
                                <Input id="post_innoviti_cb" className="maxheighter"
                                  disabled={!is_cashback_render || !is_post_cashback_render || isUPI}
                                  placeholder={val_share}
                                  value={this.state.post_innoviti_cb} onChange={(e) => {
                                    let { post_innoviti_cb } = this.state;
                                    post_innoviti_cb = e.target.value;
                                    this.setState({
                                      post_innoviti_cb: post_innoviti_cb,
                                      mapField2: false
                                    })
                                  }} />
                              </div>
                              {this.state.user_type === 'admin' ? (
                                <div className="col-md-2">
                                  <Input id="post_customer_cb" className="maxheighter"
                                    disabled={!is_cashback_render || !is_post_cashback_render || isUPI}
                                    placeholder={val_share}
                                    value={this.state.post_customer_cb} onChange={(e) => {
                                      let { post_customer_cb } = this.state;
                                      post_customer_cb = e.target.value;
                                      this.setState({
                                        post_customer_cb: post_customer_cb,
                                        mapField2: false
                                      })
                                    }} />
                                </div>
                              ) : null}
                            </div>
                          </div>
                          : null}

                        {/* Variable Subvention - SHOW but DISABLE when UPI */}
                        {this.state.subvention_participants === '1' ? (
                          <div>
                            <div className="row top-margin-10">
                              <div className="col-md-4">
                                <Label>Bank percentage of cashback on transaction</Label>
                              </div>
                              <div className="col-md-2">
                                <Input id="brand_emi" className="maxheighter" name="bank_share_of_tx"
                                  value={this.state.bank_share_of_tx} onChange={this.onChangeInput.bind(this)}
                                  disabled={isUPI} />
                              </div>
                            </div>
                            <div className="row top-margin-10">
                              <div className="col-md-4">
                                <Label>Bank maximum percentage on cashback</Label>
                              </div>
                              <div className="col-md-2">
                                <Input id="brand_emi" className="maxheighter" name="bank_max_limit_on_cashback"
                                  value={this.state.bank_max_limit_on_cashback} onChange={this.onChangeInput.bind(this)}
                                  disabled={isUPI} />
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      : null}
                    {processing_feeser()}
                    {/* {canCreateScheme && ( */}
                    {/* Update the button with cooldown display */}
                    <div className="row top-margin-10">
                      <div className="col-md-12">
                        <button
                          onClick={this.createScheme}
                          disabled={this.state.isSubmit || this.state.cooldownRemaining > 0}
                          className="btn btn-primary btn-capitalize pull-left"
                          style={{
                            opacity: (this.state.isSubmit || this.state.cooldownRemaining > 0) ? 0.6 : 1,
                            cursor: (this.state.isSubmit || this.state.cooldownRemaining > 0) ? 'not-allowed' : 'pointer'
                          }}
                        >
                          {this.state.cooldownRemaining > 0
                            ? `Wait ${this.state.cooldownRemaining}s`
                            : (this.state.isSubmit ? "Submitting..." : "Create Scheme")}
                        </button>
                        {this.state.cooldownRemaining > 0 && (
                          <span style={{ marginLeft: '10px', color: '#666', fontSize: '12px' }}>
                            Please wait {this.state.cooldownRemaining} seconds before creating another scheme
                          </span>
                        )}
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default AdminNewCreateSchemesBankEMI;